// Define a registry for section classes
const sectionRegistry = new Map();

// Register a section class
function registerSectionClass(type, sectionClass) {
  sectionRegistry.set(type, sectionClass);
}

// Get a section class by type
function getSectionClass(type) {
  return sectionRegistry.get(type);
}

// Define a registry for section block classes
const sectionBlockRegistry = new Map();

// Register a section block class
function registerSectionBlockClass(type, blockClass) {
  sectionBlockRegistry.set(type, blockClass);
}

// Get a section block class by type
function getSectionBlockClass(type) {
  return sectionBlockRegistry.get(type);
}

function toCamelCase(str) {
  return str
    .toLowerCase()
    .replace(/[^a-zA-Z0-9]+(.)/g, (m, chr) => chr.toUpperCase());
}

function toUpperFirst(str) {
  return str.charAt(0).toUpperCase() + str.slice(1);
}

class ShpfltTheme {
  constructor() {
    this.init();
  }

  init() {
    this.initSections();
    this.initializeListeners();
  }

  initSections() {
    const sections = document.querySelectorAll(".shopify-section");
    sections.forEach((section) => {
      const sectionId = section
        .querySelector("[data-section-id]")
        ?.getAttribute("data-section-id");
      if (sectionId) {
        this.registerSection(sectionId);
      }
    });
  }

  registerSection(sectionId, loadEvent = false) {
    const section = document.getElementById(`shopify-section-${sectionId}`);
    if (section) {
      const sectionClass = section.querySelector("[data-section-id]");
      if (sectionClass) {
        const sectionType = toUpperFirst(
          toCamelCase(sectionClass.getAttribute("data-section-type") || "")
        );
        const SectionClass = getSectionClass(sectionType);
        // Dynamically load the section class if it exists
        if (SectionClass) {
          if (
            typeof SectionClass.shouldLoad === "function" &&
            !SectionClass.shouldLoad(section)
          ) {
            return;
          }
          const sectionInstance = new SectionClass(section);
          sectionInstance.load(loadEvent);
        }
      }
    }
  }

  unregisterSection(sectionId, unloadEvent = false) {
    const section = document.getElementById(`shopify-section-${sectionId}`);
    if (section) {
      const sectionClass = section.querySelector("[data-section-id]");
      if (sectionClass) {
        const sectionType = toUpperFirst(
          toCamelCase(sectionClass.getAttribute("data-section-type") || "")
        );
        const SectionClass = getSectionClass(sectionType);
        if (
          SectionClass &&
          typeof SectionClass.prototype.unload === "function"
        ) {
          const sectionInstance = new SectionClass(section);
          sectionInstance.unload(unloadEvent);
        }
      }
    }
  }

  initializeListeners() {
    // Re-initialize on Shopify section load
    document.addEventListener("shopify:section:load", (event) => {
      const sectionId = event.detail.sectionId;
      this.registerSection(sectionId, true);
    });

    // Unload on Shopify section unload
    document.addEventListener("shopify:section:unload", (event) => {
      const sectionId = event.detail.sectionId;
      this.unregisterSection(sectionId, true);
    });
  }
}

// Register the Product section class
registerSectionClass(
  "Product",
  class {
    constructor(section) {
      this.section = section;
      this.blocks = [];
      this.initBlocks();
    }

    initBlocks() {
      const blocks = this.section.querySelectorAll("[data-block-type]");
      blocks.forEach((block) => {
        const blockType = toUpperFirst(
          toCamelCase(block.getAttribute("data-block-type") || "")
        );
        const BlockClass = getSectionBlockClass(blockType);
        if (BlockClass) {
          const blockInstance = new BlockClass(block, this.section);
          blockInstance.load();
          this.blocks.push(blockInstance);
        }
      });
    }

    load() {
      console.log("Product section loaded:", this.section);
      // Add your section-level initialization logic here
    }

    unload() {
      console.log("Product section unloaded:", this.section);
      // Unload all blocks
      this.blocks.forEach((blockInstance) => {
        if (typeof blockInstance.unload === "function") {
          blockInstance.unload();
        }
      });
      this.blocks = [];
    }

    static shouldLoad(section) {
      return (
        section.querySelector(".product-block > [class^='shpflt__product']") !==
        null
      );
    }
  }
);

registerSectionBlockClass(
  "AfBuyButton",
  class {
    constructor(block, section) {
      this.section = section;
      this.buyButton = block;
      this.html = document.documentElement;
      this.siteHeader = document.querySelector(".site-header");
      this.observer = null;
      this.handleVariantChange = this.handleVariantChange.bind(this);
      this.handleBuyButtonReady = this.handleBuyButtonReady.bind(this);
      // Check if sticky is disabled via data attribute
      this.disableSticky = this.buyButton.getAttribute("data-disable-sticky") === "true";
    }

    load() {
      if (!this.section || !this.buyButton || !this.siteHeader) return;

      document.addEventListener("buy-button-ready", this.handleBuyButtonReady);

      // Skip sticky behavior if disabled
      if (this.disableSticky) {
        // Listen for variant changes
        document.addEventListener("variant:change", this.handleVariantChange);

        // Check for selling plans and wait for ReCharge widget if needed
        this.initBuyButtonReady();
        return;
      }

      // Check if buyButton is out of view on load
      const rect = this.buyButton.getBoundingClientRect();
      const isOutOfViewport = rect.bottom < 0 || rect.top > window.innerHeight;

      if (isOutOfViewport) {
        this.buyButton.classList.add("sticky");
        this.html.classList.add("shpflt-sticky-buy-button");
        if (this.siteHeader.getAttribute("data-sticky") === "true") {
          // this.siteHeader.classList.add(
          //   "site-header--stuck",
          //   "site-header--opening"
          // );
        } else {
          this.buyButton.classList.add("unsticky-header");
        }
      }

      // Intersection Observer for toggling sticky/unsticky
      this.observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) {
              this.buyButton.classList.add("sticky");
              this.buyButton.classList.remove("unsticky");
              this.html.classList.add("shpflt-sticky-buy-button");
            } else if (this.buyButton.classList.contains("sticky")) {
              this.buyButton.classList.add("unsticky");
              this.buyButton.classList.remove("sticky");
              this.html.classList.remove("shpflt-sticky-buy-button");

              this.buyButton.addEventListener(
                "animationend",
                function handleAnimationEnd() {
                  this.buyButton.classList.remove("unsticky");
                  this.buyButton.removeEventListener(
                    "animationend",
                    handleAnimationEnd
                  );
                }.bind(this)
              );
            }
          });
        },
        {
          root: null,
          threshold: 0,
        }
      );

      this.observer.observe(this.buyButton);

      // Listen for variant changes
      document.addEventListener("variant:change", this.handleVariantChange);

      // Check for selling plans and wait for ReCharge widget if needed
      this.initBuyButtonReady();
    }

    initBuyButtonReady() {
      const sellingPlanIds = document.querySelectorAll('.variant-option input[type="radio"][data-selling-plan-id]');
      if (sellingPlanIds.length > 0) {
        this.waitUntilRechargeWidgetIsLoaded().then(() => {
          const checkedRadio = document.querySelector('.variant-option input[type="radio"]:checked');
          if (checkedRadio) {
            checkedRadio.dispatchEvent(new Event("change"));
          }
          document.dispatchEvent(new Event("buy-button-ready"));
        });
      } else {
        document.dispatchEvent(new Event("buy-button-ready"));
      }
    }

    waitUntilRechargeWidgetIsLoaded() {
      return new Promise((resolve) => {
        const rechargeInterval = setInterval(() => {
          if (
            typeof window.ReChargeWidget !== "undefined" &&
            document.querySelector(".rc_widget__option__plans__dropdown") !== null
          ) {
            clearInterval(rechargeInterval);
            setTimeout(() => {
              resolve();
            }, 500);
          }
        }, 100);
      });
    }

    handleBuyButtonReady(event) {
      this.enableBuyButton();
    }

    enableBuyButton() {
      console.log("Enable buy button:", this.buyButton);
      this.buyButton.removeAttribute("disabled");
      this.buyButton.classList.remove("disabled");
    }

    unload() {
      if (this.observer) {
        this.observer.disconnect();
        this.observer = null;
      }

      document.removeEventListener("variant:change", this.handleVariantChange);

      if (this.buyButton) {
        this.buyButton.classList.remove(
          "sticky",
          "unsticky",
          "unsticky-header"
        );
        this.html.classList.remove("shpflt-sticky-buy-button");
      }

      document.removeEventListener("buy-button-ready", this.handleBuyButtonReady);
    }

    handleVariantChange(event) {
      const variant = event.detail.variant;
      if (!variant) return;

      [...this.buyButton.children].forEach((button) => {
        const buttonVariantId = button.getAttribute("data-variant-id");
        if (buttonVariantId == variant.id) {
          button.classList.add("is-selected");
        } else {
          button.classList.remove("is-selected");
        }
      });
    }
  }
);

// Register the Product Subscription Options block class
registerSectionBlockClass(
  "AfSubscriptionOptions",
  class {
    constructor(block, section) {
      this.section = section;
      this.block = block;
      this.radioChangeHandler = this.radioChangeHandler.bind(this);
      this.handleBuyButtonReady = this.handleBuyButtonReady.bind(this);
    }

    load() {
      console.log("AfSubscriptionOptions block loaded:", this.block);
      document.addEventListener("buy-button-ready", this.handleBuyButtonReady);

      if (this.section) {
        const options = {
          container: this.section,
          variants: window.productVariants,
          singleOptionSelector: "[data-variant-input]",
          originalSelectorId: "[data-product-select]",
          enableHistoryState: true,
          dynamicVariantsEnabled: true,
        };

        new theme.Variants(options);
      }

      this.block
        .querySelectorAll('.variant-option input[type="radio"]')
        .forEach((radio) => {
          radio.addEventListener("change", this.radioChangeHandler);
        });
    }

    handleBuyButtonReady(event) {
      console.log("Buy button ready:", this.block);
      this.enableVariantOptions();
    }

    enableVariantOptions() {
      console.log("Enable variant options:", this.block);
      this.block.querySelectorAll('.variant-option').forEach((label) => {
        label.classList.remove("input-disabled");
      });
    }

    unload() {
      console.log("AfSubscriptionOptions block unloaded:", this.block);
      
      this.block
        .querySelectorAll('.variant-option input[type="radio"]')
        .forEach((radio) => {
          radio.removeEventListener("change", this.radioChangeHandler);
        });

      document.removeEventListener("buy-button-ready", this.handleBuyButtonReady);
    }

    radioChangeHandler(event) {
      const selectedVariantId = event.target.getAttribute("data-variant-id");
      // Update hidden input for form submission
      const hiddenInput = document.getElementById("selected-variant-id");
      if (hiddenInput) {
        hiddenInput.value = selectedVariantId;
      }

      // Update selected class for styles
      this.block.querySelectorAll(".variant-option").forEach((label) => {
        label.classList.remove("is-selected");
      });

      const closestVariantOption = event.target.closest(".variant-option");
      if (closestVariantOption) {
        closestVariantOption.classList.add("is-selected");
      }

      const sellingPlanId = event.target.getAttribute("data-selling-plan-id");
      if (sellingPlanId) {
        document.querySelector("[name=selling_plan]").value = sellingPlanId;
        document.querySelector("[name=selling_plan]").dispatchEvent(new Event("change"));
      }
    }
  }
);

// Hero Banner section
registerSectionClass(
  "ShpfltHeroBanner",
  class {
    constructor(section) {
      this.section = section;
      this.wrapper = section.querySelector(
        '[data-section-type="shpflt-hero-banner"]'
      );
      this.onResize = this.onResize.bind(this);
    }

    load() {
      if (!this.wrapper) return;
      theme.initWhenVisible({
        element: this.wrapper,
        callback: () => {
          window.addEventListener("resize", this.onResize);
        },
      });
      console.log("ShpfltHeroBanner: load");
    }

    unload() {
      if (!this.wrapper) return;
      window.removeEventListener("resize", this.onResize);
      console.log("ShpfltHeroBanner: unload");
    }

    onResize() {
      // reserved for responsive adjustments if needed
    }
  }
);

// Register the Product Bundle Suggestions Options block class
registerSectionBlockClass(
  "AfBundleSuggestions",
  class {
    windowHeight;
    windowWidth;
    constructor(block, section) {
      this.section = section;
      this.block = block;
      this.flickityInstances = [];
      this.slideshows = [];
      this.defults = {
        adaptiveHeight: true,
        avoidReflow: true,
        pageDots: false,
        prevNextButtons: false,
      };
    }

    initSlideshowInstance(slideshow, currentSize) {
      const options = {
        ...this.defults,
      };
      if (slideshow.dataset.count <= 3) {
        options.wrapAround = false;
      }
      if (["desktop", "tablet"].includes(currentSize)) {
        if (slideshow.dataset.desktopArrows === "true") {
          options.prevNextButtons = true;
        }
        if (slideshow.dataset.desktopDots === "true") {
          options.pageDots = true;
        }
      } else if (currentSize === "mobile") {
        if (slideshow.dataset.mobileArrows === "true") {
          options.prevNextButtons = true;
        }
        if (slideshow.dataset.mobileDots === "true") {
          options.pageDots = true;
        }
      }
      // Get first slide aspect ratio, and set the height of the slideshow
      const firstSlide = slideshow.querySelector(
        ".product-main-slide[data-index='0']"
      );
      if (firstSlide) {
        const aspectRatio = firstSlide.offsetWidth / firstSlide.offsetHeight;
        slideshow.style.setProperty("--aspect-ratio", aspectRatio);
      }
      const slideshowHeight = firstSlide.offsetHeight;
      slideshow.style.setProperty("--slideshow-height", `${slideshowHeight}px`);

      // Initialize Flickity
      this.flickityInstances.push(new theme.Slideshow(slideshow, options));
    }

    getCurrentSize() {
      const width = window.innerWidth;
      // return if mobile or tablet/desktop
      if (width <= 768) {
        return "mobile";
      } else if (width <= 1024) {
        return "tablet";
      } else {
        return "desktop";
      }
    }

    load(onVisible = true) {
      console.log("AfBundleSuggestions block loaded:", this.block);
      this.windowHeight = window.innerHeight;
      this.windowWidth = window.innerWidth;
      const currentSize = this.getCurrentSize();
      this.slideshows = [
        ...this.block.querySelectorAll(".bundle-slider"),
      ].filter((slideshow) => {
        // Check if the slideshow is visible
        let condition;
        switch (currentSize) {
          case "mobile":
            condition = slideshow.dataset.mobileCarousel === "true";
            break;
          case "tablet":
          case "desktop":
            condition = slideshow.dataset.desktopCarousel === "true";
            break;
          default:
            return true;
        }
        return condition && slideshow.dataset.count > 1;
      });
      if (onVisible) {
        this.slideshows.forEach((slideshow) => {
          theme.initWhenVisible({
            element: slideshow,
            callback: this.initSlideshowInstance.bind(
              this,
              slideshow,
              currentSize
            ),
            threshold: 800,
          });
        });
      } else {
        this.slideshows.forEach((slideshow) => {
          this.initSlideshowInstance(slideshow, currentSize);
        });
      }
      this.handleResize = theme.utils.debounce(
        100,
        this.handleResize.bind(this)
      );
      window.addEventListener("resize", this.handleResize);
    }

    unload() {
      console.log("AfBundleSuggestions block unloaded:", this.block);
      this.flickityInstances.forEach((flickity) => {
        flickity.destroy();
      });
      this.flickityInstances = [];
      window.removeEventListener("resize", this.handleResize);
    }

    handleResize() {
      console.log("AfBundleSuggestions: Resize event triggered.");
      const windowHeight = window.innerHeight;
      const windowWidth = window.innerWidth;
      if (this.windowWidth === windowWidth) return;
      this.unload();

      // Reinitialize slideshows
      this.load(false);
    }
  }
);

// Register the Product Bundle Suggestions Options blosck class
registerSectionBlockClass(
  "AfCarousel",
  class {
    carouselContainer;

    constructor(block, section) {
      this.section = section;
      this.block = block;
      this.handleResize = this.handleResize.bind(this);
    }

    load() {
      console.log("AfCarousel block loaded:", this.block);
      this.carouselContainer = this.block.querySelector(".carousel__container");
      window.addEventListener("resize", this.handleResize);
    }

    unload() {
      console.log("AfCarousel block unloaded:", this.block);
      window.removeEventListener("resize", this.handleResize);
    }

    handleResize() {
      const instanceIndex = window.theme.sections.instances.findIndex(
        (instance) => {
          return instance.type === "product";
        }
      );
      if (instanceIndex === -1) return;
      try {
        window.theme.Product.prototype.initProductSlider.call(
          window.theme.sections.instances[instanceIndex]
        );
      } catch (error) {
        console.error("Error reinitializing product slider:", error);
      }
    }
  }
);

// Register the Product Result Summary
registerSectionClass(
  "ShpfltProductResultSummary",
  class {
    paralaxEnabled;
    constructor(section) {
      this.section = section;
      this.blocks = [];
      this.slideshow = this.section.querySelector('.slideshow-wrapper');
      this.currentSize = this.getCurrentSize();
      this.flickityInstance = null;
    }

    getCurrentSize() {
      const width = window.innerWidth;
      // return if mobile or tablet/desktop
      if (width <= 768) {
        return "mobile";
      } else if (width <= 1024) {
        return "tablet";
      } else {
        return "desktop";
      }
    }

    animateNumbers() {
      const counters = this.section.querySelectorAll(
        ".shpflt__product-result-summary--content-metric-text h2 strong, \
       .shpflt__product-result-summary--content-result-text h2 strong"
      );

      counters.forEach((counter) => {
        if (counter.dataset.animated === "true") return;
        counter.dataset.animated = "true";
        const segments = counter.textContent.trim().split(/(\d+)/);
        const targets = segments
          .filter((_, i) => i % 2 === 1)
          .map((n) => parseInt(n, 10) || 0);

        if (!targets.length) return;

        const duration = 2000;
        const startTime = performance.now();
        const easeOut = (t) => t * (2 - t);

        const tick = (now) => {
          const progress = Math.min((now - startTime) / duration, 1);
          const eased = easeOut(progress);
          let numIdx = -1;

          counter.textContent = segments
            .map((seg, i) => {
              if (i % 2 === 0) return seg;
              numIdx += 1;
              return Math.round(targets[numIdx] * eased).toLocaleString();
            })
            .join("");

          if (progress < 1) requestAnimationFrame(tick);
        };

        requestAnimationFrame(tick);
      });
    }

    initIntakeInstance() {
      console.log("Initializing Product Result Summary instance");
      const intakeGuide = this.section.querySelector(
        ".shpflt__product-result-summary"
      );
      intakeGuide.classList.add("loading");
      const shouldAnimate = (intakeGuide?.dataset.animateNumbers ?? "true") === "true";
      if (shouldAnimate) this.animateNumbers();
      setTimeout(() => {
        intakeGuide.classList.remove("loading");
        intakeGuide.classList.add("loaded");
      }, 500);
    }

    initSlideshowInstance() {
      if (this.flickityInstance) {
        this.flickityInstance.destroy();
      }
      if (this.getCurrentSize() === 'desktop') return;

      const options = {
        cellAlign: 'left',
        contain: true,
        pageDots: this.slideshow.dataset.dots === 'true',
        prevNextButtons: this.slideshow.dataset.arrows === 'true',
        autoPlay: this.slideshow.dataset.autoplay === 'true' ? parseInt(this.slideshow.dataset.speed) : false,
        dragThreshold: 25,
        wrapAround: true,
        adaptiveHeight: false,
        setGallerySize: true,
        groupCells: 1
      };
      this.flickityInstance = new theme.Slideshow(this.slideshow, options);
    }

    load() {
      console.log("Product Intake Guide loaded:", this.section);
      theme.initWhenVisible({
        element: this.section,
        callback: () => {
          this.initIntakeInstance();
          this.initSlideshowInstance();
        },
        threshold: 0,
      });
      window.addEventListener('resize', theme.utils.debounce(250, () => {
        const newSize = this.getCurrentSize();
        if (newSize !== this.currentSize) {
          console.log(newSize);
          this.currentSize = newSize;
          this.initSlideshowInstance();
        }
      }));
    }

    unload() {
      console.log("Product Intake Guide unloaded:", this.section);
      if (this.flickityInstance) {
        this.flickityInstance.destroy();
      }
      this.flickityInstance = null;
      window.removeEventListener('resize', this.handleResize);
    }
  }
);

// Register the Product Intake Guide
registerSectionClass(
  "ShpfltProductIntakeGuide",
  class {
    paralaxEnabled;
    constructor(section) {
      this.section = section;
      this.blocks = [];
    }

    initIntakeInstance() {
      console.log("Initializing Product Intake Guide instance");
      const intakeGuide = this.section.querySelector(
        ".shpflt__product-intake-guide"
      );
      intakeGuide.classList.add("loading");
      setTimeout(() => {
        intakeGuide.classList.remove("loading");
        intakeGuide.classList.add("loaded");
      }, 500);
    }

    applyParallaxEffect() {
      if (!this.parallaxWrapper) return;

      const scrollPosition = window.scrollY;
      const offset = this.parallaxWrapper.offsetTop;
      const parallaxSpeed = 0.1; // Adjust speed as needed

      const translateY = (scrollPosition - offset) * parallaxSpeed;
      if (this.paralaxEnabled) {
        this.parallaxWrapper.style.setProperty(
          "--parallax-offset",
          `${translateY}px`
        );
      }
    }

    handleScroll() {
      this.applyParallaxEffect();
    }

    load() {
      console.log("Product Intake Guide loaded:", this.section);
      theme.initWhenVisible({
        element: this.section,
        callback: this.initIntakeInstance.bind(this),
        threshold: 0,
      });
      this.parallaxWrapper = this.section.querySelector(
        ".shpflt__product-intake-guide"
      );
      this.paralaxEnabled = this.parallaxWrapper.classList.contains(
        "background-media-text--parallax"
      );

      // Add scroll listener for parallax effect
      window.addEventListener("scroll", this.handleScroll.bind(this));
    }

    unload() {
      console.log("Product Intake Guide unloaded:", this.section);

      // Remove scroll listener
      window.removeEventListener("scroll", this.handleScroll.bind(this));
    }
  }
);

registerSectionClass(
  "ShpfltProductCaseGallery",
  class {
    constructor(section) {
      this.section = section;
      this.blocks = [];
    }

    load() {
      console.log("Product Case Gallery loaded:", this.section);
      theme.initWhenVisible({
        element: this.section,
        threshold: 0,
      });
    }
  }
);

registerSectionClass(
  "ShpfltProductComparisonImage",
  class {
    wrapper = null;
    cursor = null;
    zoom = 1.6; // magnification factor

    constructor(section) {
      this.section = section;
    }

    /* ——— section lifecycle ——— */
    load() {
      this.wrapper = this.section.querySelector(
        ".shpflt__product-comparison-image"
      );
      if (!this.wrapper) {
        console.warn("[ShpfltProductComparisonImage] wrapper missing");
        return;
      }
      if (this.wrapper.classList.contains("magnifier-mode")) {
        this.addCursor();
        this.syncBackground(); // first attempt
        this.attachEvents();
      }
    }

    unload() {
      if (!this.wrapper) return;
      this.wrapper.removeEventListener("mousemove", this.onMove);
      this.wrapper.removeEventListener("mouseenter", this.onEnter);
      this.wrapper.removeEventListener("mouseleave", this.onLeave);
      window.removeEventListener("resize", this.syncBackground);
      this.cursor.remove();
      this.cursor = null;
    }

    /* ——— create lens ——— */
    addCursor() {
      this.cursor = document.createElement("div");
      this.cursor.className = "shpflt-cursor";
      this.wrapper.appendChild(this.cursor);
    }

    /* ——— copy & upscale wrapper's background ——— */
    syncBackground = async () => {
      const cs = getComputedStyle(this.wrapper);
      const img = this.extractUrl(cs.backgroundImage);
      if (!img) {
        console.warn(
          "[ShpfltProductComparisonImage] wrapper has no background-image"
        );
        return;
      }

      /* wait for the image to load so we know its natural size */
      const { naturalWidth: nW, naturalHeight: nH } = await this.loadImage(img);

      const rect = this.wrapper.getBoundingClientRect();
      const fit = cs.backgroundSize.trim(); // e.g. "cover" | "contain" | "auto" | "50% 50%" | "600px 400px"
      const { w: dispW, h: dispH } = this.displayedSize(fit, nW, nH, rect);

      /* copy background props */
      this.cursor.style.backgroundImage = cs.backgroundImage;
      this.cursor.style.backgroundRepeat = cs.backgroundRepeat;
      this.cursor.style.backgroundPosition = cs.backgroundPosition;

      /* upscale by zoom */
      this.cursor.style.backgroundSize = `${dispW * this.zoom}px ${
        dispH * this.zoom
      }px`;
    };

    /* ——— util: extract url(...) from computed style ——— */
    extractUrl(bg) {
      const m = /url\((['"]?)(.*?)\1\)/.exec(bg);
      return m ? m[2] : null;
    }

    /* ——— util: returns a Promise that resolves with the loaded image ——— */
    loadImage(src) {
      return new Promise((res) => {
        const img = new Image();
        img.onload = () => res(img);
        img.onerror = () => res(img); // still resolve, natural size will be 0
        img.src = src;
      });
    }

    /* ——— util: what size is the bg *actually* rendered at? ——— */
    displayedSize(fit, nW, nH, rect) {
      if (fit === "cover") {
        const scale = Math.max(rect.width / nW, rect.height / nH);
        return { w: nW * scale, h: nH * scale };
      }
      if (fit === "contain") {
        const scale = Math.min(rect.width / nW, rect.height / nH);
        return { w: nW * scale, h: nH * scale };
      }
      if (fit === "auto" || fit === "auto auto") {
        return { w: nW, h: nH };
      }

      /* percentages OR px values */
      const [sx, sy] = fit.split(/\s+/);
      const w = sx.endsWith("%")
        ? (rect.width * parseFloat(sx)) / 100
        : parseFloat(sx);
      const h = sy
        ? sy.endsWith("%")
          ? (rect.height * parseFloat(sy)) / 100
          : parseFloat(sy)
        : w * (nH / nW);
      return { w, h };
    }

    /* ——— mouse handlers ——— */
    onMove = (e) => {
      const r = this.wrapper.getBoundingClientRect();
      const x = e.clientX - r.left;
      const y = e.clientY - r.top;

      this.cursor.style.left = `${x}px`;
      this.cursor.style.top = `${y}px`;

      const bgX = -(x * this.zoom - this.cursor.offsetWidth / 2);
      const bgY = -(y * this.zoom - this.cursor.offsetHeight / 2);
      this.cursor.style.backgroundPosition = `${bgX}px ${bgY}px`;
    };
    onEnter = () => this.cursor.classList.add("is-active");
    onLeave = () => this.cursor.classList.remove("is-active");

    attachEvents() {
      this.wrapper.addEventListener("mousemove", this.onMove);
      this.wrapper.addEventListener("mouseenter", this.onEnter);
      this.wrapper.addEventListener("mouseleave", this.onLeave);
      window.addEventListener("resize", this.syncBackground);
    }
  }
);

registerSectionClass(
  "ShpfltFeaturedTextCarousel",
  class {
    constructor(section) {
      this.section = section;
      this.wrapper = null;
      
      this.isDragging = false;
      this.startX = 0;
      this.scrollLeft = 0;
      this.animationId = null;
      
      this.isScrolling = false;
      this.scrollDirection = 1;
      
      /* bind once – we'll use the same fns for add/removeEventListener */
      this.onPointerDown = this.onPointerDown.bind(this);
      this.onPointerMove = this.onPointerMove.bind(this);
      this.onPointerUp = this.onPointerUp.bind(this);
      this.startInfiniteScroll = this.startInfiniteScroll.bind(this);
      this.stopInfiniteScroll = this.stopInfiniteScroll.bind(this);
      this.handleVisibilityChange = this.handleVisibilityChange.bind(this);
    }
    
    /* ---------- helpers ---------- */
    getLocalX(evt) {
      /* evt.clientX is always relative to the viewport */
      const rect = this.wrapper.getBoundingClientRect();
      return evt.clientX - rect.left;
    }
    
    /* ---------- pointer handlers ---------- */
    onPointerDown(evt) {
      /* only react to primary button / finger */
      if (!evt.isPrimary) return;
      
      // Stop infinite scrolling when user interacts
      this.stopInfiniteScroll();
      
      this.isDragging = true;
      this.wrapper.classList.add("is-dragging");
      this.wrapper.classList.add("shpflt-no-select");
      
      this.wrapper.setPointerCapture(evt.pointerId);
      
      this.startX = this.getLocalX(evt);
      this.scrollLeft = this.wrapper.scrollLeft;
    }
    
    onPointerMove(evt) {
      if (!this.isDragging) return;
      
      /* prevent native page scrolling on touch */
      evt.preventDefault();
      
      const x = this.getLocalX(evt);
      const walk = (x - this.startX) * 1.6; // tweak multiplier for speed
      this.wrapper.scrollLeft = this.scrollLeft - walk;
    }
    
    onPointerUp(evt) {
      if (!this.isDragging) return;
      
      this.isDragging = false;
      this.wrapper.classList.remove("is-dragging");
      this.wrapper.classList.remove("shpflt-no-select");
      
      this.wrapper.releasePointerCapture(evt.pointerId);
      
      // Restart infinite scrolling after user interaction
      this.startInfiniteScroll();
    }
    
    isMobile() {
      return window.matchMedia("(pointer: coarse)").matches;
    }
    
    startInfiniteScroll() {
      if (this.animationId) {
        cancelAnimationFrame(this.animationId);
      }
      
      this.isScrolling = true;
      
      const speed = parseFloat(this.wrapper.dataset.speed) || 0.5;
      const scrollStep = speed * (this.scrollDirection); // Use direction for scrolling
      
      const animate = () => {
        if (!this.isScrolling) return;
        
        if (this.wrapper.scrollLeft >= this.wrapper.scrollWidth - this.wrapper.clientWidth - 1) {
          // We've reached the end, reset to beginning for infinite effect
          this.wrapper.scrollLeft = 0;
        } else if (this.wrapper.scrollLeft <= 0 && this.scrollDirection < 0) {
          // If scrolling backwards and reached the beginning, reset to end
          this.wrapper.scrollLeft = this.wrapper.scrollWidth - this.wrapper.clientWidth;
        } else {
          // Normal scrolling
          this.wrapper.scrollLeft += scrollStep;
        }
        
        this.animationId = requestAnimationFrame(animate);
      };
      
      this.animationId = requestAnimationFrame(animate);
    }
    
    stopInfiniteScroll() {
      this.isScrolling = false;
      if (this.animationId) {
        cancelAnimationFrame(this.animationId);
        this.animationId = null;
      }
    }
    
    handleVisibilityChange() {
      if (document.hidden) {
        this.stopInfiniteScroll();
      } else {
        this.startInfiniteScroll();
      }
    }
    
    /* ---------- section lifecycle ---------- */
    load() {
      // Apply background style based on settings
      const backgroundStyle = this.section.querySelector(".shpflt__featured-text-carousel__content--texts-wrapper");
      if (backgroundStyle) {
        const style = this.section.dataset.backgroundStyle || "light";
        backgroundStyle.setAttribute("data-background-style", style);
      }
      
      this.wrapper = this.section.querySelector(
        ".shpflt__featured-text-carousel__content--texts-container"
      );
      
      if (!this.wrapper) {
        console.warn("[ShpfltFeaturedTextCarousel] wrapper missing");
        return;
      }
      
      // Add event listeners for user interaction
      this.wrapper.addEventListener("pointerdown", this.onPointerDown);
      this.wrapper.addEventListener("pointermove", this.onPointerMove);
      this.wrapper.addEventListener("pointerup", this.onPointerUp);
      this.wrapper.addEventListener("pointercancel", this.onPointerUp);
      
      // Add visibility change listener to pause animation when tab is not visible
      document.addEventListener("visibilitychange", this.handleVisibilityChange);
      
      // Start infinite scrolling
      theme.initWhenVisible({
        element: this.section,
        threshold: 0,
        callback: this.startInfiniteScroll,
      });
    }
    
    unload() {
      if (!this.wrapper) return;
      
      this.stopInfiniteScroll();
      
      this.wrapper.removeEventListener("pointerdown", this.onPointerDown);
      this.wrapper.removeEventListener("pointermove", this.onPointerMove);
      this.wrapper.removeEventListener("pointerup", this.onPointerUp);
      this.wrapper.removeEventListener("pointercancel", this.onPointerUp);
      
      document.removeEventListener("visibilitychange", this.handleVisibilityChange);
    }
  }
);

registerSectionClass(
  "ShpfltProductClinicCarousel",
  class {
    constructor(section) {
      this.section = section;
      this.wrapper = null;

      this.isDragging = false;
      this.startX = 0;
      this.scrollLeft = 0;

      /* bind once – we'll use the same fns for add/removeEventListener */
      this.onPointerDown = this.onPointerDown.bind(this);
      this.onPointerMove = this.onPointerMove.bind(this);
      this.onPointerUp = this.onPointerUp.bind(this);
    }

    /* ---------- helpers ---------- */
    getLocalX(evt) {
      /* evt.clientX is always relative to the viewport */
      const rect = this.wrapper.getBoundingClientRect();
      return evt.clientX - rect.left;
    }

    /* ---------- pointer handlers ---------- */
    onPointerDown(evt) {
      /* only react to primary button / finger */
      if (!evt.isPrimary) return;

      this.isDragging = true;
      this.wrapper.classList.add("is-dragging");
      this.wrapper.classList.add("shpflt-no-select");

      this.wrapper.setPointerCapture(evt.pointerId);

      this.startX = this.getLocalX(evt);
      this.scrollLeft = this.wrapper.scrollLeft;
    }

    onPointerMove(evt) {
      if (!this.isDragging) return;

      /* prevent native page scrolling on touch */
      evt.preventDefault();

      const x = this.getLocalX(evt);
      const walk = (x - this.startX) * 1.6; // tweak multiplier for speed
      this.wrapper.scrollLeft = this.scrollLeft - walk;
    }

    onPointerUp(evt) {
      if (!this.isDragging) return;

      this.isDragging = false;
      this.wrapper.classList.remove("is-dragging");
      this.wrapper.classList.remove("shpflt-no-select");

      this.wrapper.releasePointerCapture(evt.pointerId);
    }

    isMobile() {
      return window.matchMedia("(pointer: coarse)").matches;
    }

    initialAnimation() {
      if (!this.wrapper) return;

      const maxScrollLeft = this.wrapper.scrollWidth - this.wrapper.clientWidth;
      console.log("[ShpfltProductClinicCarousel] scrollWidth:", this.wrapper.scrollWidth);
      console.log("[ShpfltProductClinicCarousel] clientWidth:", this.wrapper.clientWidth);
      console.log("[ShpfltProductClinicCarousel] maxScrollLeft:", maxScrollLeft);
      
      if (maxScrollLeft <= 0) {
        console.warn("[ShpfltProductClinicCarousel] No scrollable content detected");
        return;
      }
      
      let direction = 1; // 1 for right, -1 for left
      let currentScroll = 0;
      const speed = parseFloat(this.wrapper.dataset.speed) || 2; // Use dataset speed or default to 2

      const animate = () => {
        currentScroll += direction * speed; // Adjust speed dynamically

        if (currentScroll >= maxScrollLeft) {
          direction = -1; // Change direction to left
        } else if (currentScroll <= 0) {
          direction = 1; // Change direction to right
        }

        this.wrapper.scrollLeft = currentScroll;
        requestAnimationFrame(animate);
      };

      animate();
    }

    load() {
      console.log("Product Clinic Carousel loaded:", this.section);

      if (this.isMobile()) {
        return; // no dragging on mobile
      }

      this.wrapper = this.section.querySelector(
        ".shpflt__product-clinic-carousel__content--images-container"
      );
      if (!this.wrapper) {
        console.warn("[ShpfltProductClinicCarousel] wrapper missing");
        return;
      }

      const mode = this.wrapper.dataset.mode; // 'grab', 'auto-scroll', 'animate-on-load'
      console.log(mode);

      if (mode === "auto-scroll") {
        theme.initWhenVisible({
          element: this.section,
          threshold: 0,
          callback: this.initialAnimation.bind(this),
        });
      } else if (mode === "animate-on-load") {
        theme.initWhenVisible({
          element: this.section,
          threshold: 0,
          callback: this.animateOnLoad.bind(this),
        });
      }

      if (mode === "grab" || mode === "animate-on-load") {
        this.wrapper.addEventListener("pointerdown", this.onPointerDown);
        this.wrapper.addEventListener("pointermove", this.onPointerMove);
        this.wrapper.addEventListener("pointerup", this.onPointerUp);
        this.wrapper.addEventListener("pointercancel", this.onPointerUp);

        /* prevent default image-drag ghost */
        this.wrapper
          .querySelectorAll("img,svg")
          .forEach((img) => (img.draggable = false));
      }
    }

    unload() {
      if (!this.wrapper) return;

      this.wrapper.removeEventListener("pointerdown", this.onPointerDown);
      this.wrapper.removeEventListener("pointermove", this.onPointerMove);
      this.wrapper.removeEventListener("pointerup", this.onPointerUp);
      this.wrapper.removeEventListener("pointercancel", this.onPointerUp);
    }
  }
);

registerSectionClass(
  "ShpfltProductScientificEvidence",
  class {
    constructor(section) {
      this.section = section;
      this.blocks = [];
      this.content = null;
      this.showMoreButton = null;
      this.hiddenItems = [];
      this.originalHiddenItemsStatus = new Map(); // Store initial hidden state
      this.isExpanded = false; // Track current state
    }

    load() {
      console.log("Product Scientific Evidence loaded:", this.section);

      // Get the content container and any hidden items
      this.content = this.section.querySelector(
        ".shpflt__product-scientific-content"
      );

      if (!this.content) return;

      // Get hidden items (in case they're already rendered from server-side)
      this.hiddenItems = this.content.querySelectorAll("li");

      // Store the original hidden state of each item
      this.hiddenItems.forEach((item, index) => {
        const isHidden = item.classList.contains("hidden");
        this.originalHiddenItemsStatus.set(index, isHidden);
      });

      // Set the initial state class on the main container
      const evidenceContainer = this.section.querySelector(
        ".shpflt__product-scientific-evidence"
      );
      if (evidenceContainer) {
        evidenceContainer.classList.add("is-collapsed");
      }

      // Get the "Show More" button if it exists
      this.showMoreButton = this.content.querySelector(
        ".shpflt__product-scientific-button"
      );

      if (this.showMoreButton) {
        // Remove the inline onClick handler and add our event listener
        const originalButton = this.showMoreButton;
        const newButton = originalButton.cloneNode(true);
        newButton.removeAttribute("onclick");
        newButton.addEventListener("click", this.toggleHiddenItems.bind(this));
        originalButton.parentNode.replaceChild(newButton, originalButton);
        this.showMoreButton = newButton;
      }

      // Initialize any animations or effects
      theme.initWhenVisible({
        element: this.section,
        callback: this.initSectionAnimation.bind(this),
        threshold: 0.2,
      });
    }

    toggleHiddenItems() {
      if (!this.content) return;

      // Toggle between expanded and collapsed states
      this.isExpanded = !this.isExpanded;

      // Get the main container
      const evidenceContainer = this.section.querySelector(
        ".shpflt__product-scientific-evidence"
      );

      if (this.isExpanded) {
        // Show all items when expanded
        this.hiddenItems.forEach((item) => {
          item.classList.remove("hidden");
        });
        if (this.showMoreButton) {
          this.showMoreButton.textContent =
            this.showMoreButton.getAttribute("data-view-less");
        }
        // Add expanded class to the main container
        if (evidenceContainer) {
          evidenceContainer.classList.add("is-expanded");
          evidenceContainer.classList.remove("is-collapsed");
        }
      } else {
        // Restore original state when collapsed
        this.hiddenItems.forEach((item, index) => {
          const wasHidden = this.originalHiddenItemsStatus.get(index);
          if (wasHidden) {
            item.classList.add("hidden");
          } else {
            item.classList.remove("hidden");
          }
        });
        // Change button text to "Ver más"
        if (this.showMoreButton) {
          this.showMoreButton.textContent =
            this.showMoreButton.getAttribute("data-view-more");
        }
        // Add collapsed class to the main container
        if (evidenceContainer) {
          evidenceContainer.classList.remove("is-expanded");
          evidenceContainer.classList.add("is-collapsed");
        }

        // Scroll to the top of the section when collapsing
        this.section.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    }

    initSectionAnimation() {
      // Add any animations or effects when the section becomes visible
      if (this.content) {
        this.content.classList.add("is-visible");
      }
    }

    unload() {
      console.log("Product Scientific Evidence unloaded:", this.section);

      // Remove event listeners
      if (this.showMoreButton) {
        this.showMoreButton.removeEventListener(
          "click",
          this.toggleHiddenItems
        );
      }
    }
  }
);

// Register the Product Active Ingredients
registerSectionClass(
  "ShpfltProductFaqSection",
  class {
    constructor(section) {
      this.section = section;
      this.faqContainer = null;
      this.faqItems = [];
    }

    load() {
      console.log("Product FAQ Section loaded:", this.section);

      // Get the FAQ container
      this.faqContainer = this.section.querySelector(
        ".shpflt__product-faq-section__wrapper"
      );

      if (!this.faqContainer) return;

      // Initialize any animations or effects when the section becomes visible
      theme.initWhenVisible({
        element: this.section,
        callback: this.initSectionAnimation.bind(this),
        threshold: 0.2,
      });
    }

    initSectionAnimation() {
      // Add animation class when section becomes visible
      if (this.faqContainer) {
        this.faqContainer.classList.add("is-visible");
      }
    }

    unload() {
      console.log("Product FAQ Section unloaded:", this.section);
    }
  }
);

registerSectionClass(
  "ShpfltProductActiveIngredients",
  class {
    constructor(section) {
      this.section = section;
      this.blocks = [];
      this.toggleButton = null;
      this.wrapper = null;
      this.scrollContent = null;
      this.scrollThreshold = 20; // px from top/bottom to consider "at position"
      this.activeFilters = new Set(); // Stores active filter values
      this.ingredientItems = []; // All ingredient items to filter
      this.filterForm = null; // Form containing filter checkboxes
      this.applyButton = null; // Apply filters button
      this.mobileCheckboxes = []; // Checkboxes in the expandable filter area
      this.filterCheckboxes = []; // Checkboxes in the non-expandable area
      this.noResultsMessage = null; // No results message element
      this.filterMode = 'single'; // In single mode, only one filter can be active at a time
      this.itemsContainer = null; // Container for ingredient items
      this.paginationContainer = null; // Pagination container
      this.paginationSquares = null; // Pagination squares container
      this.currentPage = 0; // Current active page (0-indexed)
      this.itemsPerRow = 1; // Number of items visible per row
      this.sectionWrapper = null; // Main section wrapper
      this.isInitialLoad = true; // Track if this is the initial page load
    }

    get headerHeight() {
      const header = document.querySelector(".site-header");
      return header ? header.offsetHeight : 0;
    }

    load() {
      console.log("Product Active Ingredients loaded:", this.section);
      this.toggleButton = this.section.querySelector(
        ".shpflt__product-active-ingredients--toggle"
      );
      this.wrapper = this.section.querySelector(".ingredients-filter-wrapper");
      this.scrollContent = this.section.querySelector(
        ".ingredients-filter-content"
      );
      this.filterForm = this.section.querySelector(
        ".shpflt__product-active-ingredients__filter"
      );
      this.applyButton = this.section.querySelector(
        ".shpflt__product-active-ingredients--apply"
      );
      this.ingredientItems = this.section.querySelectorAll(
        ".shpflt__product-active-ingredients__item"
      );
      this.noResultsMessage = this.section.querySelector(
        ".shpflt__product-active-ingredients__filter-no-results"
      );
      this.itemsContainer = this.section.querySelector(
        ".shpflt__product-active-ingredients__items"
      );
      this.paginationContainer = this.section.querySelector(
        "[data-pagination-container]"
      );
      this.paginationSquares = this.section.querySelector(
        "[data-pagination-squares]"
      );
      this.sectionWrapper = this.section.querySelector(
        ".shpflt__product-active-ingredients__wrapper"
      );

      // Get all filter checkboxes - both in the expandable and non-expandable areas
      this.mobileCheckboxes = this.section.querySelectorAll(
        ".ingredients-filter-checkbox"
      );
      this.filterCheckboxes = this.section.querySelectorAll(
        ".shpflt__product-active-ingredients__filter-checkbox"
      );

      if (this.toggleButton) {
        this.toggleButton.addEventListener(
          "click",
          this.handleToggle.bind(this)
        );
      }

      if (this.scrollContent) {
        this.scrollContent.addEventListener(
          "scroll",
          this.handleScroll.bind(this)
        );
        // Initial check
        this.checkScrollPosition();
      }

      if (this.wrapper) {
        this.wrapper.style.setProperty(
          "--header-height",
          `${this.headerHeight}px`
        );
      }

      // Setup filter functionality
      this.setupFilterListeners();

      // Initialize all items as visible (not filtered out)
      this.ingredientItems.forEach((item) => {
        item.setAttribute("data-filtered-out", "false");
      });

      // Setup pagination - delay to ensure layout is ready
      setTimeout(() => {
        this.initPagination();
      }, 100);

      this.handleResize = theme.utils.debounce(
        100,
        this.handleResize.bind(this)
      );
      window.addEventListener("resize", this.handleResize);
    }

    handleResize() {
      if (!this.wrapper) return;
      const headerHeight = this.headerHeight;
      this.wrapper.style.setProperty("--header-height", `${headerHeight}px`);

      // Re-check scroll position after resize
      if (this.scrollContent) {
        this.checkScrollPosition();
      }

      // Recalculate pagination after resize
      const previousPage = this.currentPage;
      this.updatePagination();
      
      // After updating pagination, refresh the visible items for the current page
      // Check if current page is still valid after resize
      const visibleItems = Array.from(this.ingredientItems).filter(
        (item) => item.getAttribute("data-filtered-out") !== "true"
      );
      if (visibleItems.length > 0 && this.itemsPerRow > 0) {
        const totalPages = Math.ceil(visibleItems.length / this.itemsPerRow);
        // If current page is out of bounds, go to the last valid page
        if (this.currentPage >= totalPages && totalPages > 0) {
          this.currentPage = totalPages - 1;
        }
        // Refresh the visible items for the current page (without scrolling on resize)
        this.goToPage(this.currentPage, false);
      }
    }

    handleToggle() {
      if (!this.toggleButton) return;
      const isExpanded = this.wrapper.classList.toggle("is-expanded");

      // Re-check scroll position after toggle
      if (isExpanded && this.scrollContent) {
        setTimeout(() => this.checkScrollPosition(), 100);
      }
    }

    handleScroll() {
      if (!this.scrollContent) return;
      this.checkScrollPosition();
    }

    checkScrollPosition() {
      if (!this.scrollContent) return;

      const { scrollTop, scrollHeight, clientHeight } = this.scrollContent;
      const maxScroll = scrollHeight - clientHeight;

      // Remove existing position classes
      this.scrollContent.classList.remove(
        "is-scroll-top",
        "is-scroll-middle",
        "is-scroll-bottom"
      );

      // Check if there's actually overflow content
      if (scrollHeight <= clientHeight) {
        // No overflow, don't add any scroll position class
        this.wrapper.setAttribute("data-scroll-position", "none");
        return;
      }

      // Determine scroll position
      if (scrollTop <= this.scrollThreshold) {
        this.scrollContent.classList.add("is-scroll-top");
        this.wrapper.setAttribute("data-scroll-position", "top");
      } else if (scrollTop >= maxScroll - this.scrollThreshold) {
        this.scrollContent.classList.add("is-scroll-bottom");
        this.wrapper.setAttribute("data-scroll-position", "bottom");
      } else {
        this.scrollContent.classList.add("is-scroll-middle");
        this.wrapper.setAttribute("data-scroll-position", "middle");
      }
    }

    setupFilterListeners() {
      // Handle direct checkbox filters (non-expanded view)
      this.filterCheckboxes.forEach((checkbox) => {
        checkbox.addEventListener("change", this.handleFilterChange.bind(this));
      });

      // Handle mobile checkboxes in expandable area
      this.mobileCheckboxes.forEach((checkbox) => {
        checkbox.addEventListener("change", this.syncCheckboxes.bind(this));
      });

      // Handle apply button click
      if (this.applyButton) {
        this.applyButton.addEventListener(
          "click",
          this.handleApplyFilters.bind(this)
        );
      }

      // Prevent form submission
      if (this.filterForm) {
        this.filterForm.addEventListener("submit", (e) => e.preventDefault());
      }
    }

    // Sync checkbox states between expanded and non-expanded views
    syncCheckboxes(event) {
      const checkbox = event.target;
      const { value, checked } = checkbox;
    
      if (this.filterMode === 'single') {
        // Uncheck all others
        [...this.filterCheckboxes, ...this.mobileCheckboxes].forEach(cb => {
          cb.checked = false;
        });
        checkbox.checked = checked; // Re-check the clicked one
      }
    
      this.syncCheckboxStates(checkbox);
      this.applyFilters();
    }

    // Handle checkbox change in the non-expandable filters area
    handleFilterChange(event) {
      const checkbox = event.target;
      const label = checkbox.closest('label');
    
      if (this.filterMode === 'single') {
        // Uncheck all checkboxes
        [...this.filterCheckboxes, ...this.mobileCheckboxes].forEach(cb => {
          if (cb !== checkbox) cb.checked = false;
        });
      }
    
      // Update label state
      if (label) {
        label.classList.toggle('active', checkbox.checked);
      }
    
      this.syncCheckboxStates(checkbox); // Sync UI for corresponding checkbox
      this.applyFilters();
    }

    // Handle apply button click in the expandable filter area
    handleApplyFilters() {
      this.applyFilters();

      // Close the expanded filter
      if (this.wrapper && this.wrapper.classList.contains("is-expanded")) {
        this.wrapper.classList.remove("is-expanded");
      }
    }

    // Apply the filters and show/hide ingredients
    applyFilters() {
      // Clear active filters
      this.activeFilters.clear();

      // Collect active filter values from both checkbox sets
      const allCheckboxes = [
        ...this.filterCheckboxes,
        ...this.mobileCheckboxes,
      ];
      const checkedFilters = new Set();

      allCheckboxes.forEach((checkbox) => {
        if (checkbox.checked) {
          checkedFilters.add(checkbox.value);
        }
      });

      // If no filters are checked, show all items
      if (checkedFilters.size === 0) {
        this.ingredientItems.forEach((item) => {
          item.setAttribute("data-filtered-out", "false");
          item.style.display = "";
        });
        if (this.noResultsMessage) {
          this.noResultsMessage.classList.remove('is-visible');
        }
        // Reset to first page and update pagination
        this.currentPage = 0;
        this.updatePagination();
        // Show first page after reset (without scrolling)
        if (this.itemsPerRow > 0) {
          this.goToPage(0, false);
        }
        return;
      }

      // Filter the ingredients
      let hasVisibleItems = false;
      this.ingredientItems.forEach((item) => {
        // Get all tags for this ingredient
        const tagElements = item.querySelectorAll(".shpflt__product-tags .tag");
        const itemTags = new Set();

        tagElements.forEach((tag) => {
          // Get tag's value in a format matching our filter values (handle format)
          const tagValue = tag
            .getAttribute("data-tag-handle")
            .trim()
            .toLowerCase()
            .replace(/\s+/g, "-");
          itemTags.add(tagValue);
        });

        // Check if any of the ingredient's tags match any active filter
        const hasMatchingTag = Array.from(checkedFilters).every((filter) =>
          Array.from(itemTags).some(
            (tag) => tag.includes(filter) || filter.includes(tag)
          )
        );

        // Track filter state with data attribute
        item.setAttribute("data-filtered-out", hasMatchingTag ? "false" : "true");

        // Show or hide based on filter match
        item.style.display = hasMatchingTag ? "" : "none";
        if (hasMatchingTag) {
          hasVisibleItems = true;
        }
      });

      // Show/hide no results message
      if (this.noResultsMessage) {
        this.noResultsMessage.classList.toggle('is-visible', !hasVisibleItems);
      }

      // Reset to first page and update pagination after filtering
      this.currentPage = 0;
      this.updatePagination();
      // Show first page after filtering (without scrolling)
      if (this.itemsPerRow > 0) {
        this.goToPage(0, false);
      }
    }

    syncCheckboxStates(sourceCheckbox) {
      const { value, checked } = sourceCheckbox;
    
      [...this.filterCheckboxes, ...this.mobileCheckboxes].forEach((checkbox) => {
        if (checkbox !== sourceCheckbox && checkbox.value === value) {
          checkbox.checked = checked;
    
          const label = checkbox.closest('label');
          if (label) label.classList.toggle('active', checked);
        } else if (this.filterMode === 'single' && checkbox !== sourceCheckbox) {
          checkbox.checked = false;
    
          const label = checkbox.closest('label');
          if (label) label.classList.remove('active');
        }
      });
    }

    // Calculate how many items are visible per row
    calculateItemsPerRow() {
      if (!this.itemsContainer || this.ingredientItems.length === 0) {
        return 1;
      }

      // Temporarily show all visible items to calculate layout
      const visibleItems = Array.from(this.ingredientItems).filter(
        (item) => item.getAttribute("data-filtered-out") !== "true"
      );

      if (visibleItems.length === 0) {
        return 1;
      }

      // Temporarily show all visible items to measure layout
      const originalDisplays = new Map();
      visibleItems.forEach((item) => {
        originalDisplays.set(item, item.style.display);
        item.style.display = "";
      });

      // Force a reflow to ensure layout is calculated
      void this.itemsContainer.offsetHeight;

      // Get the first visible item's position
      const firstItem = visibleItems[0];
      if (!firstItem || !firstItem.offsetParent) {
        // Restore original displays
        visibleItems.forEach((item) => {
          item.style.display = originalDisplays.get(item) || "";
        });
        return 1;
      }

      const firstItemTop = firstItem.getBoundingClientRect().top;

      // Count items in the same row (same top position, within tolerance)
      let itemsInRow = 1;
      const tolerance = 10; // pixels tolerance for same row detection

      for (let i = 1; i < visibleItems.length; i++) {
        const item = visibleItems[i];
        if (!item.offsetParent) continue;
        
        const itemTop = item.getBoundingClientRect().top;

        // Check if item is in the same row (similar top position)
        if (Math.abs(itemTop - firstItemTop) < tolerance) {
          itemsInRow++;
        } else {
          // We've moved to the next row, stop counting
          break;
        }
      }

      // Restore original displays
      visibleItems.forEach((item) => {
        item.style.display = originalDisplays.get(item) || "";
      });

      return itemsInRow;
    }

    // Initialize pagination
    initPagination() {
      if (!this.paginationSquares || !this.itemsContainer) return;

      this.updatePagination();
      
      // Show first page after initialization (without scrolling)
      if (this.itemsPerRow > 0) {
        this.goToPage(0, false); // false = don't scroll on initial load
      }
      
      // Mark initial load as complete
      this.isInitialLoad = false;
    }

    // Update pagination based on visible items
    updatePagination() {
      if (!this.paginationSquares || !this.itemsContainer) return;

      // Get visible items (not filtered out) - check data attribute instead of display
      const visibleItems = Array.from(this.ingredientItems).filter(
        (item) => item.getAttribute("data-filtered-out") !== "true"
      );

      if (visibleItems.length === 0) {
        if (this.paginationContainer) {
          this.paginationContainer.style.display = "none";
        }
        return;
      }

      // Calculate items per row
      this.itemsPerRow = this.calculateItemsPerRow();

      // Calculate total pages
      const totalPages = Math.ceil(visibleItems.length / this.itemsPerRow);

      // Only show pagination if there's more than one page
      if (totalPages <= 1) {
        if (this.paginationContainer) {
          this.paginationContainer.style.display = "none";
        }
        return;
      }

      // Show pagination container
      if (this.paginationContainer) {
        this.paginationContainer.style.display = "flex";
      }

      // Clear existing pagination squares
      this.paginationSquares.innerHTML = "";

      // Determine which pages to show (max 3 squares)
      let pagesToShow = [];
      
      if (totalPages <= 3) {
        // Show all pages if 3 or fewer
        for (let i = 0; i < totalPages; i++) {
          pagesToShow.push(i);
        }
      } else {
        // Show max 3 pages: current page and adjacent pages
        if (this.currentPage === 0) {
          // On first page: show first 3 pages
          pagesToShow = [0, 1, 2];
        } else if (this.currentPage === totalPages - 1) {
          // On last page: show last 3 pages
          pagesToShow = [totalPages - 3, totalPages - 2, totalPages - 1];
        } else {
          // In middle: show previous, current, next
          pagesToShow = [this.currentPage - 1, this.currentPage, this.currentPage + 1];
        }
      }

      // Create pagination squares (max 3)
      for (let i = 0; i < pagesToShow.length; i++) {
        const pageIndex = pagesToShow[i];
        const square = document.createElement("button");
        square.type = "button";
        square.className = "shpflt__product-active-ingredients__pagination-square";
        square.setAttribute("data-page", pageIndex);
        square.setAttribute("aria-label", `Go to page ${pageIndex + 1}`);
        
        if (pageIndex === this.currentPage) {
          square.classList.add("is-active");
        }

        square.addEventListener("click", () => {
          this.goToPage(pageIndex, true); // true = scroll when user clicks
        });

        this.paginationSquares.appendChild(square);
      }
    }

    // Navigate to a specific page
    goToPage(pageIndex, shouldScroll = true) {
      if (!this.itemsContainer) return;

      // Get all items that are not filtered out (they may have display: none from pagination)
      // We need to check the original filter state, not the pagination state
      const allItems = Array.from(this.ingredientItems);
      
      // First, restore all items to their filter state (remove pagination hiding)
      // We'll use a data attribute to track if an item should be visible based on filters
      allItems.forEach((item) => {
        const isFilteredOut = item.getAttribute("data-filtered-out") === "true";
        if (!isFilteredOut) {
          // Item should be visible based on filters, but we'll control pagination separately
          item.style.display = "";
        }
      });

      // Now get items that are visible (not filtered out)
      const visibleItems = allItems.filter(
        (item) => item.getAttribute("data-filtered-out") !== "true"
      );

      if (visibleItems.length === 0) return;

      const totalPages = Math.ceil(visibleItems.length / this.itemsPerRow);
      if (pageIndex < 0 || pageIndex >= totalPages) return;

      // Calculate start and end indices for the page
      const startIndex = pageIndex * this.itemsPerRow;
      const endIndex = Math.min(startIndex + this.itemsPerRow, visibleItems.length);

      // Hide all visible items first (for pagination)
      visibleItems.forEach((item) => {
        item.style.display = "none";
      });

      // Show items for the current page
      for (let i = startIndex; i < endIndex; i++) {
        if (visibleItems[i]) {
          visibleItems[i].style.display = "";
        }
      }

      // Update current page
      this.currentPage = pageIndex;

      // Update pagination squares active state
      const squares = this.paginationSquares.querySelectorAll(
        ".shpflt__product-active-ingredients__pagination-square"
      );
      squares.forEach((square, index) => {
        if (index === pageIndex) {
          square.classList.add("is-active");
        } else {
          square.classList.remove("is-active");
        }
      });

      // Scroll to top of wrapper only if shouldScroll is true (user clicked pagination)
      if (shouldScroll && this.sectionWrapper) {
        this.sectionWrapper.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    }

    unload() {
      console.log("Product Active Ingredients unloaded:", this.section);
      if (this.toggleButton) {
        this.toggleButton.removeEventListener(
          "click",
          this.handleToggle.bind(this)
        );
        this.toggleButton = null;
      }

      if (this.scrollContent) {
        this.scrollContent.removeEventListener(
          "scroll",
          this.handleScroll.bind(this)
        );
        this.scrollContent = null;
      }

      if (this.wrapper) {
        this.wrapper.style.setProperty("--header-height", "0px");
        this.wrapper.classList.remove("is-expanded");
        this.wrapper.removeAttribute("data-scroll-position");
        this.wrapper = null;
      }

      // Clean up filter listeners
      this.filterCheckboxes.forEach((checkbox) => {
        checkbox.removeEventListener(
          "change",
          this.handleFilterChange.bind(this)
        );
      });

      this.mobileCheckboxes.forEach((checkbox) => {
        checkbox.removeEventListener("change", this.syncCheckboxes.bind(this));
      });

      if (this.applyButton) {
        this.applyButton.removeEventListener(
          "click",
          this.handleApplyFilters.bind(this)
        );
        this.applyButton = null;
      }

      if (this.filterForm) {
        this.filterForm.removeEventListener("submit", (e) =>
          e.preventDefault()
        );
        this.filterForm = null;
      }

      window.removeEventListener("resize", this.handleResize);
    }
  }
);

// Register the Quiz Invitation
registerSectionClass(
  "ShpfltProductQuizInvitation",
  class {
    constructor(section) {
      this.section = section;
      this.blocks = [];
      this.initBlocks();
    }

    load() {
      console.log("Quiz Invitation loaded:", this.section);
    }


    initBlocks() {
      const blocks = this.section.querySelectorAll("[data-block-type]");
      blocks.forEach((block) => {
        const blockType = toUpperFirst(
          toCamelCase(block.getAttribute("data-block-type") || "")
        );
        const BlockClass = getSectionBlockClass(blockType);
        if (BlockClass) {
          const blockInstance = new BlockClass(block, this.section);
          blockInstance.load();
          this.blocks.push(blockInstance);
        }
      });
    }
    unload() {
      console.log("Quiz Invitation section unloaded:", this.section);
      // Unload all blocks
      this.blocks.forEach((blockInstance) => {
        if (typeof blockInstance.unload === "function") {
          blockInstance.unload();
        }
      });
      this.blocks = [];
    }
  }
);

// Register the section class
registerSectionClass(
  "ShpfltAlert",
  class {
    intervals = [];

    constructor(section) {
      this.section = section;
    }

    load() {
      console.log("Alert Bar loaded:", this.section);
      this.initCountdowns();
      this.screenSizeChange();
      window.addEventListener('resize', this.screenSizeChange.bind(this));
      window.addEventListener('click', this.handleClickOutside.bind(this));
      this.section.querySelectorAll('[data-terms]').forEach(terms => {
        terms.addEventListener('click', this.toggleTerms.bind(this));
      });
    }

    getTextsWidth() {
      const texts = this.section.querySelectorAll('.shpflt__alert__static span');
      let width = 0;
      texts.forEach(text => {
        width += text.offsetWidth;
      });
      return width;
    }

    screenSizeChange() {
      if (!this.section.querySelector('.shpflt__alert__static')) return;
      const size = window.innerWidth;
      const textsWidth = this.getTextsWidth();
      if (size < 768 && textsWidth > size) {
        this.section.querySelector('.shpflt__alert__inner').setAttribute('data-mode', 'rotatory');
      } else {
        this.section.querySelector('.shpflt__alert__inner').setAttribute('data-mode', 'static');
      }
    }
    
    handleClickOutside(event) {
      if (this.section.querySelector('.shpflt__alert__terms').classList.contains('is-visible')) {
        this.toggleTerms();
      }
    }

    toggleTerms() {
      const terms = this.section.querySelector('.shpflt__alert__terms');
      if (terms.classList.contains('is-visible')) {
        terms.classList.remove('is-visible');
        document.body.classList.remove('is-terms-active');
      } else {
        terms.classList.add('is-transitioning-in');
        document.body.classList.add('is-terms-active');
        setTimeout(() => {
          terms.classList.add('is-visible');
          terms.classList.remove('is-transitioning-in');
        }, 300);
      }
    }

    unload() {
      // Clear all intervals to prevent memory leaks
      this.intervals.forEach(interval => clearInterval(interval));
      window.removeEventListener('resize', this.screenSizeChange.bind(this));
      this.intervals = [];
      window.removeEventListener('click', this.handleClickOutside);
    }

    initCountdowns() {
      const countdowns = this.section.querySelectorAll('.shpflt__alert__countdown');
      
      countdowns.forEach(countdown => {
        const endDate = new Date(countdown.dataset.endDate).getTime();
        const endText = countdown.dataset.endText;
        
        const updateCountdown = () => {
          const now = new Date().getTime();
          const distance = endDate - now;
          
          if (distance < 0) {
            countdown.innerHTML = endText;
            return;
          }
          
          const hours = Math.floor(distance / (1000 * 60 * 60));
          const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
          const seconds = Math.floor((distance % (1000 * 60)) / 1000);
          countdown.querySelector('.countdown-hours').textContent = String(hours).padStart(2, '0');
          countdown.querySelector('.countdown-minutes').textContent = String(minutes).padStart(2, '0');
          countdown.querySelector('.countdown-seconds').textContent = String(seconds).padStart(2, '0');
        };
        
        updateCountdown();
        const interval = setInterval(updateCountdown, 1000);
        this.intervals.push(interval);
      });
    }
  }
);

registerSectionClass(
  "ShpfltProductExpectationTimeline",
  class {
    constructor(section) {
      this.section = section;
      this.wrapper = section;
      this.tabs = section.querySelectorAll('.shpflt__product-expectation-timeline__tab');
      this.contents = section.querySelectorAll('.shpflt__product-expectation-timeline__item');
      
      if (!this.wrapper) return;
      
      // Bind the handler to preserve 'this' context
      this.handleTabClick = this.handleTabClick.bind(this);
    }

    load() {
      console.log("Product Expectation Timeline loaded:", this.section);
      this.init();
    }

    init() {
      // Add click event listeners to all tabs
      this.tabs.forEach(tab => {
        tab.addEventListener('click', this.handleTabClick);
      });
    }

    handleTabClick(event) {
      const tab = event.currentTarget;
      const tabId = tab.dataset.tab;

      console.log('Tab clicked:', tabId);

      // Update active tab
      this.tabs.forEach(t => t.classList.remove('active'));
      tab.classList.add('active');

      // Update active content
      this.contents.forEach(content => {
        content.classList.remove('active');
        if (content.dataset.tabContent === tabId) {
          content.classList.add('active');
        }
      });
    }

    unload() {
      // Remove click event listeners from all tabs
      this.tabs.forEach(tab => {
        tab.removeEventListener('click', this.handleTabClick);
      });
    }
  }
);

registerSectionClass(
  "ShpfltBanner",
  class {
    constructor(section) {
      this.section = section;
      this.wrapper = section.querySelector(".shpflt__banner");
      this.blocks = this.wrapper ? this.wrapper.querySelector('.blocks[data-init-animation]') : null;
      this._animationTimeout = null;
    }
    animateNumbers() {
      if (!this.blocks) return;
      const counters = this.blocks.querySelectorAll('.number-animate');
      counters.forEach((counter) => {
        if (counter.dataset.animated === "true") return;
        counter.dataset.animated = "true";
        const segments = counter.textContent.trim().split(/(\d+)/);
        const targets = segments
          .filter((_, i) => i % 2 === 1)
          .map((n) => parseInt(n, 10) || 0);
        if (!targets.length) return;
        const duration = 2000;
        const startTime = performance.now();
        const easeOut = (t) => t * (2 - t);
        const tick = (now) => {
          const progress = Math.min((now - startTime) / duration, 1);
          const eased = easeOut(progress);
          let numIdx = -1;
          counter.textContent = segments
            .map((seg, i) => {
              if (i % 2 === 0) return seg;
              numIdx += 1;
              return Math.round(targets[numIdx] * eased).toLocaleString();
            })
            .join("");
          if (progress < 1) requestAnimationFrame(tick);
        };
        requestAnimationFrame(tick);
      });
    }
    load() {
      if (!this.blocks) return;
      this.blocks.classList.remove("is-animated");
      const anim = this.blocks.getAttribute("data-init-animation");
      if (anim && anim !== "none") {
        this._animationTimeout = setTimeout(() => {
          this.blocks.classList.add("is-animated");
          this.animateNumbers();
        }, 100);
      } else {
        this.animateNumbers();
      }
    }
    unload() {
      if (!this.blocks) return;
      this.blocks.classList.remove("is-animated");
      if (this._animationTimeout) {
        clearTimeout(this._animationTimeout);
        this._animationTimeout = null;
      }
    }
  }
);

registerSectionClass(
  "ShpfltProductAutoplayVideoGallery",
  class {
    constructor(section) {
      this.section = section;
      this.slideshow = this.section.querySelector('.video-slideshow');
      this.currentSize = this.getCurrentSize();
      this.flickityInstance = null;
    }

    load() {
      if (!this.slideshow) return;

      theme.initWhenVisible({
        element: this.section,
        callback: this.initSlideshowInstance.bind(this),
        threshold: 200
      });

      window.addEventListener('resize', theme.utils.debounce(250, () => {
        const newSize = this.getCurrentSize();
        if (newSize !== this.currentSize) {
          this.currentSize = newSize;
          this.initSlideshowInstance();
          this.syncHeight();
        }
      }));
    }

    initSlideshowInstance() {
      if (this.flickityInstance) {
        this.flickityInstance.destroy();
      }

      const itemsPerRow = theme.config.bpSmall ? 1 : (parseInt(this.slideshow.dataset.desktopItems) || 4);
      this.slideshow.style.setProperty('--items-per-row', itemsPerRow);

      const options = {
        cellAlign: 'left',
        contain: true,
        pageDots: this.slideshow.dataset.dots === 'true',
        prevNextButtons: this.slideshow.dataset.arrows === 'true',
        autoPlay: this.slideshow.dataset.autoplay === 'true' ? parseInt(this.slideshow.dataset.speed) : false,
        dragThreshold: 25,
        wrapAround: true,
        adaptiveHeight: false,
        setGallerySize: true,
        groupCells: 1
      };

      this.flickityInstance = new theme.Slideshow(this.slideshow, options);
      this.syncHeight();
    }

    syncHeight() {
      if (this.flickityInstance) {
        const currentHeight = this.flickityInstance.slideshow.maxCellHeight;
        this.slideshow.style.setProperty('--max-cell-height', `${currentHeight}px`);
      }
    }

    getCurrentSize() {
      return window.innerWidth < 768 ? 'mobile' : 'desktop';
    }

    unload() {
      if (this.flickityInstance) {
        this.flickityInstance.destroy();
      }
    }
  }
);

registerSectionBlockClass(
  "ShpfltQuizInvitationContent",
  class {
    constructor(block, section) {
      this.block = block;
      this.section = section;
      this.quizContainer = null;
      this.quizButton = null;
      this.inlineWrapper = null;
      this.closeButton = null;
      this.typeformLoaded = false;
      this.typeformUrl = null;
      this.contentType = null;
      this.iframeType = null;
      this.popupSize = null;
      this.sliderPosition = null;
      this.openInNewTab = false;
      this.typeformWidget = null;
    }

    loadTypeformResources() {
      return new Promise((resolve) => {
        // Check if TypeForm script is already loaded
        if (
          document.querySelector(
            'script[src*="embed.typeform.com/next/embed.js"]'
          )
        ) {
          this.typeformLoaded = true;
          resolve();
          return;
        }

        // Load TypeForm script
        const typeformScript = document.createElement("script");
        typeformScript.src = "//embed.typeform.com/next/embed.js";
        typeformScript.async = true;

        // Load TypeForm CSS
        const typeformCSS = document.createElement("link");
        typeformCSS.rel = "stylesheet";
        typeformCSS.href = "//embed.typeform.com/next/css/popup.css";

        // Set the typeform CSS to load only if the script is loaded
        const typeformSliderCSS = document.createElement("link");
        typeformSliderCSS.rel = "stylesheet";
        typeformSliderCSS.href = "//embed.typeform.com/next/css/slider.css";

        const typeformWidgetCSS = document.createElement("link");
        typeformWidgetCSS.rel = "stylesheet";
        typeformWidgetCSS.href = "//embed.typeform.com/next/css/widget.css";

        // Add the resources to the document
        document.head.appendChild(typeformCSS);
        document.head.appendChild(typeformSliderCSS);
        document.head.appendChild(typeformWidgetCSS);
        document.head.appendChild(typeformScript);

        typeformScript.onload = () => {
          this.typeformLoaded = true;
          resolve();
        };

        typeformScript.onerror = () => {
          console.error("Failed to load TypeForm script");
          resolve(); // Resolve anyway to prevent hanging
        };
      });
    }

    handleCloseButtonClick = (event) => {
      event.preventDefault();
      
      // Close the TypeForm widget
      if (this.typeformWidget) {
        // Try to close the widget programmatically
        try {
          // If TypeForm widget has a close method, use it
          if (typeof this.typeformWidget.close === 'function') {
            this.typeformWidget.close();
          }
        } catch (error) {
          console.error("Error closing TypeForm widget:", error);
        }
        
        // Reset the widget reference
        this.typeformWidget = null;
      }
      
      // Hide the inline wrapper
      if (this.inlineWrapper) {
        this.inlineWrapper.style.display = 'none';
        this.inlineWrapper.innerHTML = '';
      }
      
      // Remove the active class from the container
      const container = this.section.querySelector('.shpflt__product-quiz-invitation__container');
      if (container) {
        container.classList.remove('is-typeform-active');
      }
      
      // Show the button again
      if (this.quizButton) {
        this.quizButton.style.display = '';
        this.quizButton.classList.remove('btn--loading');
      }
    };
    
    isMobile() {
      return window.innerWidth < 768 || 
        (('ontouchstart' in window) && 
        (navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0));
    }
    
    handleButtonClick = async (event) => {
      event.preventDefault();
      // Get content URL from the section
      if (!this.typeformUrl) {
        return;
      }

      // Handle different content types
      if (this.contentType === "iframe") {
        // Load TypeForm resources if not already loaded
        if (!this.typeformLoaded) {
          await this.loadTypeformResources();
        }

        // Check if on mobile
        const isMobileDevice = this.isMobile();

        // Launch TypeForm popup if the library is available
        if (window.tf) {
          // Always use popup with large size on mobile
          if (isMobileDevice) {
            const options = { size: 80 }; // Large size
            window.tf.createPopup(this.typeformUrl, options).open();
          } else if (this.iframeType === "popup") {
            // Create popup with size setting
            const size = this.popupSize === "large" ? 80 : this.popupSize === "medium" ? 60 : 40;
            const options = { size };
            window.tf.createPopup(this.typeformUrl, options).open();
          } else if (this.iframeType === "slider") {
            // Create slider with position setting
            const position = this.sliderPosition === "left" ? "left" : "right";
            const options = { position };
            window.tf.createSlider(this.typeformUrl, options).open();
          } else if (this.iframeType === "inline") {
            // Initialize the inline widget on button click
            this.initInlineWidget();
          } else {
            // Default to popup if type is unknown
            window.tf.createPopup(this.typeformUrl).open();
          }
        } else {
          console.error("TypeForm library not available");
          // Fallback - open in new tab if TypeForm fails to load
          window.open(this.typeformUrl, "_blank");
        }
      } else if (this.contentType === "external") {
        // Open external URL in a new tab or current window
        if (this.openInNewTab) {
          window.open(this.typeformUrl, "_blank");
        } else {
          window.location.href = this.typeformUrl;
        }
      }
    };

    load() {
      console.log("Quiz Invitation Content loaded:", this.section);

      // Get the quiz container and button
      this.quizButton = this.block.querySelector(
        ".shpflt__product-quiz-invitation__button"
      );
      this.inlineWrapper = this.block.querySelector(
        ".shpflt__product-quiz-invitation__inline__wrapper"
      );
      this.closeButton = this.block.querySelector(
        ".shpflt__product-quiz-invitation__inline__close-button"
      );

      if (!this.block || !this.quizButton) return;

      // Get content URL and settings from data attributes
      if (this.block) {
        this.typeformUrl = 
          this.block.getAttribute("data-section-iframe-url") || 
          this.block.getAttribute("data-content-url") || 
          this.block.getAttribute("data-content-url");
        
        this.contentType = 
          this.block.getAttribute("data-section-content-type") || 
          this.block.getAttribute("data-content-type") || 
          this.block.getAttribute("data-content-type") || 
          "iframe";
        
        this.iframeType = 
          this.block.getAttribute("data-section-iframe-type") || 
          "popup";
        
        this.popupSize = 
          this.block.getAttribute("data-section-popup-size") || 
          "large";

        this.sliderPosition =
          this.block.getAttribute("data-section-slider-position") || 
          "right";
          
        this.openInNewTab = 
          this.block.getAttribute("data-open-in-new-tab") === "true" || 
          this.block.getAttribute("data-open-in-new-tab") === "true";

      }

      // Add click event listener to the button
      this.quizButton.addEventListener("click", this.handleButtonClick);
      
      // Add click event listener to the close button
      if (this.closeButton) {
        this.closeButton.addEventListener("click", this.handleCloseButtonClick);
      }

      // Initialize when visible in viewport
      theme.initWhenVisible({
        element: this.block,
        callback: this.initSectionAnimation.bind(this),
        threshold: 0.2,
      });
    }

    initSectionAnimation() {
      // Add animation classes or perform other initialization when section becomes visible
      if (this.quizContainer) {
        this.quizContainer.classList.add("is-visible");
        // All widget types, including inline, will be initialized only on button click
      }
    }
    
    async initInlineWidget() {
      // If typeform resources aren't loaded yet, load them
      if (!this.typeformLoaded) {
        await this.loadTypeformResources();
      }
      
      // Check if on mobile device
      if (this.isMobile() && window.tf) {
        // On mobile, use popup with large size instead of inline
        const options = { size: 80 }; // Large size
        window.tf.createPopup(this.typeformUrl, options).open();
        return;
      }
      
      if (window.tf && this.typeformUrl && this.inlineWrapper) {
        // Add a class to the container element when inline button is clicked
        if (this.block) {
          this.block.classList.add('is-typeform-active');
        }
        
        // Create widget in the inline wrapper
        this.typeformWidget = window.tf.createWidget(this.typeformUrl, {
          container: this.inlineWrapper,
          transitiveSearchParams: ['utm_source', 'utm_medium', 'utm_campaign'],
          hidden: { source: 'website' },
          onReady: () => {
            // Remove loading class from the button
            this.quizButton.classList.remove('btn--loading');
          }
        });
        
        // Show the inline wrapper
        this.inlineWrapper.style.display = 'block';
        // Hide the button after clicking
        this.quizButton.classList.add('btn--loading');
      } else {
        console.error("Could not initialize inline widget - missing element or TypeForm library");
        // Fall back to popup if there's an issue
        if (window.tf) {
          window.tf.createPopup(this.typeformUrl).open();
        } else {
          // Last resort fallback if TypeForm library failed to load
          window.open(this.typeformUrl, "_blank");
        }
      }
    }

    unload() {
      console.log("Product Quiz Invitation unloaded:", this.section);

      // Remove event listeners
      if (this.quizButton) {
        this.quizButton.removeEventListener("click", this.handleButtonClick);
      }
      
      if (this.closeButton) {
        this.closeButton.removeEventListener("click", this.handleCloseButtonClick);
      }
      
      // Clean up the typeform widget if it exists
      if (this.typeformWidget) {
        try {
          // If TypeForm widget has a close method, use it before nullifying
          if (typeof this.typeformWidget.close === 'function') {
            this.typeformWidget.close();
          }
        } catch (error) {
          console.error("Error closing TypeForm widget during unload:", error);
        }
        this.typeformWidget = null;
      }
      
      if (this.inlineWrapper) {
        // Clear the inline wrapper
        this.inlineWrapper.innerHTML = '';
      }
      
      // Remove the active class from the container
      const container = this.block.querySelector('.shpflt__product-quiz-invitation__container');
      if (container) {
        container.classList.remove('is-typeform-active');
      }
    }
  }
);

let activeCatTmp = null;
registerSectionClass(
  "Header",
  class {
    constructor(section) {
      this.section = section;
      this.menuElement = section.querySelector('.shpflt__header-menu');
      this.menuElementWrapper = section.querySelector('.shpflt__header-menu-wrapper');
      this.menuToggle = section.querySelector('.shpflt-nav__link');
      this.blocks = [];
      this.categories = [];
      this.tabContents = [];
      this.activeCategory = null;

      // Bind event handlers once for add/remove
      this.handleMenuClick = this.handleMenuClick.bind(this);
      this.handleCategoryClick = this.handleCategoryClick.bind(this);
      this.handleBlockSelect = this.handleBlockSelect.bind(this);
      this.handleSectionSelect = this.handleSectionSelect.bind(this);
      this.handleClickOutside = this.handleClickOutside.bind(this);
      this.handleEscapeKey = this.handleEscapeKey.bind(this);
      this.handlePredictiveSearchOpen = this.handlePredictiveSearchOpen.bind(this);
      this.handlePredictiveSearchClose = this.handlePredictiveSearchClose.bind(this);

      this.headerMenuTitleObserver = null;
      this.categoryObserver = null;

      this.initBlocks();
    }

    initBlocks() {
      const blocks = this.section.querySelectorAll("[data-block-type]");
      blocks.forEach((block) => {
        const blockType = toUpperFirst(toCamelCase(block.getAttribute("data-block-type") || ""));
        const BlockClass = getSectionBlockClass(blockType);
        if (BlockClass) {
          const blockInstance = new BlockClass(block, this.section);
          blockInstance.load();
          this.blocks.push(blockInstance);
        }
      });
    }

    load(loadEvent = false) {
      console.log("Header Menu loaded:", this.section);
      this.initMenuStructure(loadEvent);
      this.attachEvents();
    }

    initMenuStructure(loadEvent = false) {
      if (!this.menuElementWrapper) return;
      // Get categories and tab contents
      this.categories = Array.from(this.menuElementWrapper.querySelectorAll('.shpflt__header-menu-category'));
      if (this.categories.length === 0 && window.Alpine && typeof Alpine.initTree === 'function') {
        Alpine.initTree(this.section);
        return this.initMenuStructure(loadEvent);
      }
      this.tabContents = Array.from(
        this.menuElementWrapper.querySelectorAll(
          '.shpflt__header-menu-content .tab-content, .shpflt__header-menu-category-wrapper .tab-content'
        )
      );
      // Set up initial state
      if (this.categories.length > 0) {
        if (activeCatTmp !== null) {
          this.activeCategory = this.categories[activeCatTmp];
        }
        if (this.activeCategory) {
          this.toggleCategory(this.activeCategory, loadEvent, true);
        } else {
          this.toggleCategory(this.categories[0], loadEvent);
        }
      }
    }

    toggleCategory(category, isBlockSelect = false, force = false) {
      if (!category || !this.menuElement) return;
      // If the menu is not active and the category is selected from a block, activate the menu.
      if (!this.menuElement.classList.contains('is-active') && isBlockSelect) {
        this.menuElement.classList.add('is-active');
        document.body.classList.add('is-menu-active');
      }
      const isActive = category.classList.contains('active');

      this.categories.forEach(cat => cat.classList.remove('active'));

      if (!category.classList.contains('shpflt__header-menu-link')) {
        // Remove active class from all categories and tab contents
        this.tabContents.forEach(content => content.classList.remove('active'));
      }

      if (isActive && !isBlockSelect && !force) return;

      // Add active class to selected category
      category.classList.add('active');

      if (category.classList.contains('shpflt__header-menu-link')) {
        return;
      }

      // Find and activate corresponding tab content
      const categoryId = category.getAttribute('data-block-id');
      this.tabContents
        .filter(content => content.getAttribute('data-block-id') === categoryId)
        .forEach(content => content.classList.add('active'));

      this.activeCategory = category;
      let index = this.categories.indexOf(category);
      if (index !== -1) {
        activeCatTmp = index;
      }
    }

    attachEvents() {
      if (this.menuToggle) {
        this.menuToggle.addEventListener('click', this.handleMenuClick);
      }

      this.categories.forEach(category => {
        category.addEventListener('click', this.handleCategoryClick);
      });

      this.initTitleSticky();
      this.initCategorySticky();

      document.addEventListener('shopify:block:select', this.handleBlockSelect);
      document.addEventListener('shopify:section:select', this.handleSectionSelect);
      document.addEventListener('click', this.handleClickOutside);
      document.addEventListener('keydown', this.handleEscapeKey);
      document.addEventListener('predictive-search:open', this.handlePredictiveSearchOpen);
      document.addEventListener('predictive-search:close', this.handlePredictiveSearchClose);
    }

    // Sticky header title observer
    initTitleSticky() {
      const headerMenuTitle = this.menuElementWrapper?.querySelector('.shpflt__header-menu-header-wrapper');
      const stickyDiv = this.menuElementWrapper?.querySelector('.shpflt__header-menu-header-sentinel');
      if (!headerMenuTitle || !stickyDiv) return;

      this.headerMenuTitleObserver = new IntersectionObserver(
        ([entry]) => {
          headerMenuTitle.classList.toggle("is-stuck", entry.intersectionRatio < 1);
        },
        { threshold: [0.03] }
      );
      this.headerMenuTitleObserver.observe(stickyDiv);
    }

    destroyTitleSticky() {
      if (this.headerMenuTitleObserver) {
        const stickyDiv = this.menuElementWrapper?.querySelector('.shpflt__header-menu-header-sentinel');
        this.headerMenuTitleObserver.disconnect();
        if (stickyDiv) {
          const headerMenuTitle = this.menuElementWrapper.querySelector('.shpflt__header-menu-header-wrapper');
          if (headerMenuTitle) headerMenuTitle.classList.remove('is-stuck');
        }
        this.headerMenuTitleObserver = null;
      }
    }

    // Sticky category observer
    initCategorySticky() {
      const categories = this.menuElementWrapper?.querySelectorAll('.shpflt__header-menu-category-wrapper');
      const stickyDiv = this.menuElementWrapper?.querySelector('.shpflt__header-menu-category-sentinel');
      if (!categories || !stickyDiv) return;

      this.categoryObserver = new IntersectionObserver(
        ([entry]) => {
          categories.forEach(category => {
            category.classList.toggle("is-stuck", entry.intersectionRatio < 1);
          });
        },
        { threshold: [0.03] }
      );
      this.categoryObserver.observe(stickyDiv);
    }

    destroyCategorySticky() {
      if (this.categoryObserver) {
        this.categoryObserver.disconnect();
        const categories = this.menuElementWrapper?.querySelectorAll('.shpflt__header-menu-category-wrapper');
        if (categories) {
          categories.forEach(category => category.classList.remove('is-stuck'));
        }
        this.categoryObserver = null;
      }
    }

    handleCategoryClick(event) {
      this.toggleCategory(event.currentTarget);
      // Prevent the default behavior of the link
      if (!event.currentTarget.classList.contains('shpflt__header-menu-link')) {
        event.preventDefault();
      }
    }

    handleBlockSelect(event) {
      const block = event.target.closest('.shpflt__header-menu-category');
      if (!block) return;
      const blockId = block.getAttribute('id');
      const category = this.menuElementWrapper.querySelector(`.shpflt__header-menu-category[data-block-id="${blockId}"]`);
      if (category) {
        this.toggleCategory(category, true);
      }
    }

    handleMenuClick(event) {
      event.preventDefault();
      const menu = this.menuElement;
      if (menu.classList.contains('is-active')) {
        menu.classList.add('is-transitioning-out');
        setTimeout(() => {
          menu.classList.remove('is-active', 'is-transitioning-out', 'is-transitioning-in');
          document.body.classList.remove('is-menu-active');
        }, 300);
      } else {
        menu.classList.add('is-transitioning-in', 'is-active');
        document.body.classList.add('is-menu-active');
        setTimeout(() => {
          menu.classList.remove('is-transitioning-in');
        }, 300);
      }
    }

    handleSectionSelect(event) {
      console.log(this.menuElement, event.target);
      // if (this.menuElement.classList.contains('is-active')) {
      //   this.menuElement.classList.add('is-active');
      //   document.body.classList.add('is-menu-active');
      // }
    }

    handleClickOutside(event) {
      if (
        this.menuElement.classList.contains('is-active') &&
        !this.menuElement.contains(event.target) &&
        !this.menuToggle.contains(event.target) &&
        !event.target.closest('.tf-v1-popup')
      ) {
        this.handleMenuClick(event);
      }
    }

    handleEscapeKey(event) {
      if (event.key === 'Escape' && this.menuElement.classList.contains('is-active')) {
        this.handleMenuClick(event);
      }
    }

    handlePredictiveSearchOpen() {
      if (this.menuElement.classList.contains('is-active')) {
        this.handleMenuClick(new Event('click'));
      }
    }

    handlePredictiveSearchClose() {
      if (this.menuElement.classList.contains('is-active')) {
        this.handleMenuClick(new Event('click'));
      }
    }

    unload() {
      console.log("Header Menu unloaded:", this.section);

      // Unload all blocks
      this.blocks.forEach(blockInstance => {
        if (typeof blockInstance.unload === "function") {
          blockInstance.unload();
        }
      });

      // Remove category event listeners
      this.categories.forEach(category => {
        category.removeEventListener('click', this.handleCategoryClick);
      });

      // Remove document event listeners
      document.removeEventListener('shopify:block:select', this.handleBlockSelect);
      document.removeEventListener('shopify:section:select', this.handleSectionSelect);
      document.removeEventListener('click', this.handleClickOutside);
      document.removeEventListener('keydown', this.handleEscapeKey);
      document.removeEventListener('predictive-search:open', this.handlePredictiveSearchOpen);
      document.removeEventListener('predictive-search:close', this.handlePredictiveSearchClose);

      // Remove menu toggle event listener
      if (this.menuToggle) {
        this.menuToggle.removeEventListener('click', this.handleMenuClick);
      }

      this.destroyTitleSticky();
      this.destroyCategorySticky();

      this.blocks = [];
      this.categories = [];
      this.tabContents = [];
      this.activeCategory = null;
    }
  }
);

registerSectionClass(
  "ShpfltProductFeaturedTestimonials",
  class {
    constructor(section) {
      this.section = section;
      this.wrapper = this.section.querySelector('[data-section-type="shpflt-product-featured-testimonials"]');
      this.loadMoreBtn = this.wrapper.querySelector('[data-action="load-more"]');
      this.loadMoreBtnContainer = this.wrapper.querySelector('.shpflt__product-featured-testimonials--load-more');
      this.content = this.wrapper.querySelector('.shpflt__product-featured-testimonials--content');
      this.items = this.wrapper.querySelectorAll('.shpflt__product-featured-testimonials--item');
      this.itemsPerLoad = this.loadMoreBtn ? parseInt(this.loadMoreBtn.dataset.itemsPerLoad, 10) : 3;
      this.totalItems = parseInt(this.wrapper.dataset.totalItems, 10);
      this.visibleItems = parseInt(this.wrapper.dataset.initialItems, 10);
      this.resizeObserver = null;
      this.isTabletOrDesktop = false;
      this.currentColumns = 0;

      this.onLoadMore = this.onLoadMore.bind(this);
      this.handleResize = theme.utils.debounce(250, this.checkMasonryLayout.bind(this));
    }

    load() {
      if (!this.wrapper) return;
      if (this.loadMoreBtn) {
        this.loadMoreBtn.addEventListener('click', this.onLoadMore);
        this.updateLoadMoreButton();
      }
      
      // Initialize masonry layout on tablet/desktop
      this.checkMasonryLayout();
      
      // Watch for resize events
      window.addEventListener('resize', this.handleResize);
      
      // Watch for content changes (when items are shown/hidden)
      if (this.content && window.MutationObserver) {
        this.resizeObserver = new MutationObserver(() => {
          this.checkMasonryLayout();
        });
        this.resizeObserver.observe(this.content, {
          childList: true,
          subtree: true,
          attributes: true,
          attributeFilter: ['class']
        });
      }
    }

    unload() {
      if (this.loadMoreBtn) {
        this.loadMoreBtn.removeEventListener('click', this.onLoadMore);
      }
      window.removeEventListener('resize', this.handleResize);
      if (this.resizeObserver) {
        this.resizeObserver.disconnect();
      }
    }

    checkMasonryLayout() {
      if (!this.content || !this.items.length) return;
      
      // Check if we're on tablet (481px to 1024px) or desktop (min-width: 1025px)
      const isTablet = window.matchMedia('(min-width: 481px) and (max-width: 1024px)').matches;
      const isDesktop = window.matchMedia('(min-width: 1025px)').matches;
      const isTabletOrDesktop = isTablet || isDesktop;
      
      // Determine number of columns
      let columns = 0;
      if (isDesktop) {
        columns = 3;
      } else if (isTablet) {
        columns = 2;
      }
      
      if (isTabletOrDesktop && !this.isTabletOrDesktop) {
        // Just switched to tablet/desktop, apply masonry
        this.isTabletOrDesktop = true;
        this.currentColumns = columns;
        this.applyMasonryLayout(columns);
      } else if (!isTabletOrDesktop && this.isTabletOrDesktop) {
        // Just switched from tablet/desktop, remove masonry
        this.isTabletOrDesktop = false;
        this.currentColumns = 0;
        this.removeMasonryLayout();
      } else if (isTabletOrDesktop && this.currentColumns !== columns) {
        // Columns changed (tablet to desktop or vice versa), update layout
        this.currentColumns = columns;
        this.applyMasonryLayout(columns);
      } else if (isTabletOrDesktop) {
        // Already on tablet/desktop with same columns, just update layout
        this.applyMasonryLayout(columns);
      }
    }

    applyMasonryLayout(columns = 3) {
      if (!this.content) return;
      
      const visibleItems = Array.from(this.items).filter(item => 
        !item.classList.contains('hidden') && item.offsetParent !== null
      );
      
      if (visibleItems.length === 0) return;
      
      // Get computed styles for gap
      const computedStyle = window.getComputedStyle(this.content);
      const gap = parseFloat(computedStyle.gap) || 32; // Default to 32px (2rem) if gap not set
      const columnHeights = new Array(columns).fill(0);
      
      // Calculate container width
      const containerWidth = this.content.offsetWidth;
      const columnWidth = (containerWidth - (gap * (columns - 1))) / columns;
      
      // First, measure all item heights with correct width
      const itemHeights = [];
      visibleItems.forEach(item => {
        // Temporarily reset positioning to measure
        const originalPosition = item.style.position;
        const originalTop = item.style.top;
        const originalLeft = item.style.left;
        const originalWidth = item.style.width;
        
        // Set to normal flow with correct width for measurement
        item.style.position = 'static';
        item.style.top = '';
        item.style.left = '';
        item.style.width = `${columnWidth}px`;
        
        // Force reflow
        void item.offsetHeight;
        
        // Measure height
        const height = item.offsetHeight || item.getBoundingClientRect().height || 200;
        itemHeights.push(height);
        
        // Restore original styles
        item.style.position = originalPosition;
        item.style.top = originalTop;
        item.style.left = originalLeft;
        item.style.width = originalWidth;
      });
      
      // Now position items in masonry layout with horizontal ordering
      visibleItems.forEach((item, index) => {
        // Find the shortest column
        const shortestColumnIndex = columnHeights.indexOf(Math.min(...columnHeights));
        
        // Calculate left position
        const leftPosition = shortestColumnIndex * (columnWidth + gap);
        
        // Get item height from measured heights
        const itemHeight = itemHeights[index];
        
        // Set position and dimensions
        item.style.position = 'absolute';
        item.style.left = `${leftPosition}px`;
        item.style.top = `${columnHeights[shortestColumnIndex]}px`;
        item.style.width = `${columnWidth}px`;
        
        // Update column height
        columnHeights[shortestColumnIndex] += itemHeight + gap;
      });
      
      // Set container height to accommodate all items
      const maxHeight = Math.max(...columnHeights);
      this.content.style.height = `${maxHeight}px`;
    }

    removeMasonryLayout() {
      if (!this.items || !this.content) return;
      
      this.content.style.height = '';
      this.items.forEach(item => {
        item.style.position = '';
        item.style.top = '';
        item.style.left = '';
        item.style.width = '';
        item.style.marginTop = '';
        item.style.transform = '';
      });
    }

    async onLoadMore() {
      if (!this.loadMoreBtn) return;
      
      // Add loading state
      this.loadMoreBtn.classList.add('btn--loading');
      this.loadMoreBtn.setAttribute('disabled', true);

      // Simulate loading delay
      await new Promise(resolve => setTimeout(resolve, 500));

      const hiddenItems = Array.from(this.items).filter(item => item.classList.contains('hidden'));
      const itemsToShow = hiddenItems.slice(0, this.itemsPerLoad);

      itemsToShow.forEach(item => {
        item.classList.remove('hidden');
        item.classList.add('showing');
      });

      this.visibleItems += itemsToShow.length;
      
      // Remove loading state
      this.loadMoreBtn.classList.remove('btn--loading');
      this.updateLoadMoreButton();
      
      // Recalculate masonry layout after showing new items
      setTimeout(() => {
        if (this.isTabletOrDesktop) {
          this.applyMasonryLayout(this.currentColumns);
        }
      }, 100);
    }

    updateLoadMoreButton() {
      if (!this.loadMoreBtn || !this.loadMoreBtnContainer) return;
      
      if (this.visibleItems >= this.totalItems) {
        this.loadMoreBtn.setAttribute('disabled', true);
        this.loadMoreBtnContainer.classList.add('is-hidden');
      } else {
        this.loadMoreBtn.removeAttribute('disabled');
        this.loadMoreBtnContainer.classList.remove('is-hidden');
      }
    }
  }
);

// Register the Saciada Calculator section class
registerSectionClass(
  "ShpfltSaciadaCalculator",
  class {
    constructor(section) {
      this.section = section;
      this.wrapper = this.section.querySelector('[data-section-type="shpflt-saciada-calculator"]');
      this.weightSlider = null;
      this.heightSlider = null;
      this.weightValue = null;
      this.heightValue = null;
      this.resultText = null;
      this.resultsText = null;
      
      // Store bound functions for proper cleanup
      this.boundHandleWeightChange = this.handleWeightChange.bind(this);
      this.boundHandleHeightChange = this.handleHeightChange.bind(this);
      
      // Debounced functions
      this.debouncedCalculateResults = theme.utils.debounce(150,this.calculateResults.bind(this));
    }

    load() {
      console.log("SaciadaCalculator loaded:", this.section);
      this.initElements();
      this.bindEvents();
      // Don't calculate results on load - show placeholder until user interacts
    }

    initElements() {
      this.weightSlider = this.wrapper.querySelector('#weight-slider');
      this.heightSlider = this.wrapper.querySelector('#height-slider');
      this.weightValue = this.wrapper.querySelector('#weight-value');
      this.heightValue = this.wrapper.querySelector('#height-value');
      this.resultText = this.wrapper.querySelector('#result-text');
      this.resultsText = this.wrapper.querySelector('#results-text');
    }

    bindEvents() {
      if (this.weightSlider) {
        this.weightSlider.addEventListener('input', this.boundHandleWeightChange);
      }
      if (this.heightSlider) {
        this.heightSlider.addEventListener('input', this.boundHandleHeightChange);
      }
    }

    handleWeightChange() {
      const weight = parseFloat(this.weightSlider.value);
      const min = parseFloat(this.weightSlider.min);
      const max = parseFloat(this.weightSlider.max);
      const progress = ((weight - min) / (max - min)) * 100;
      
      // Update slider progress on track wrapper
      const weightTrackWrapper = this.wrapper.querySelector('#weight-track-wrapper');
      if (weightTrackWrapper) {
        weightTrackWrapper.style.setProperty('--progress', `${progress}%`);
      }
      
      // Display the actual slider value with proper decimal formatting
      this.weightValue.textContent = `${weight.toFixed(1).replace('.', ',')} KG`;
      this.debouncedCalculateResults();
    }

    handleHeightChange() {
      const height = parseInt(this.heightSlider.value);
      const min = parseInt(this.heightSlider.min);
      const max = parseInt(this.heightSlider.max);
      const progress = ((height - min) / (max - min)) * 100;
      
      // Update slider progress on track wrapper
      const heightTrackWrapper = this.wrapper.querySelector('#height-track-wrapper');
      if (heightTrackWrapper) {
        heightTrackWrapper.style.setProperty('--progress', `${progress}%`);
      }
      
      this.heightValue.textContent = `${(height / 100).toFixed(2).replace('.', ',')} CM`;
      this.debouncedCalculateResults();
    }

    calculateResults() {
      const weight = parseFloat(this.weightSlider.value);
      const height = parseInt(this.heightSlider.value);
      
      // BMI calculation
      const altura_m = height / 100;
      const bmi = weight / (altura_m ** 2);
      
      // Weight loss calculation using exact formula
      let perdidaKg = 0;
      
      // Always calculate weight loss, but adjust formula based on BMI
      if (bmi < 20) {
        // Very low BMI - minimal weight loss
        perdidaKg = Math.round(weight * 0.02); // 2% max
      } else if (bmi < 25) {
        // Normal BMI - moderate weight loss
        perdidaKg = Math.round(weight * 0.05); // 5% max
      } else if (bmi <= 32) {
        // Overweight - original formula
        const porcentaje = 0.05 + 0.00166 * bmi + 0.00012 * (bmi ** 2);
        perdidaKg = Math.round(weight * porcentaje);
      } else {
        // Obese - maximum weight loss
        perdidaKg = Math.round(weight * 0.1212);
      }
      
      // Update UI using schema settings
      if (perdidaKg > 0) {
        const resultButtonText = this.wrapper.dataset.resultButtonText
          .replace('$weight_loss', '<span class="animated-number">' + perdidaKg + '</span>');
        const resultsTextWithData = this.wrapper.dataset.resultsTextWithData
          .replace('$bmi', '<span class="animated-number">' + Math.round(bmi) + '</span>')
          .replace('$weight_loss', '<span class="animated-number">' + perdidaKg + '</span>');
          
        this.resultText.innerHTML = resultButtonText;
        this.resultsText.innerHTML = resultsTextWithData;
        
        // Animate the numbers
        this.animateNumbers();
      } else {
        this.resultText.textContent = this.wrapper.dataset.resultButtonPlaceholder;
        this.resultsText.textContent = this.wrapper.dataset.resultsTextPlaceholder;
      }
    }

    animateNumbers() {
      const animatedNumbers = this.wrapper.querySelectorAll('.animated-number');
      
      animatedNumbers.forEach(element => {
        const targetValue = parseInt(element.textContent);
        const duration = 1000; // 1 second
        const startTime = performance.now();
        
        const animate = (currentTime) => {
          const elapsed = currentTime - startTime;
          const progress = Math.min(elapsed / duration, 1);
          
          // Easing function for smooth animation
          const easeOutCubic = 1 - Math.pow(1 - progress, 3);
          const currentValue = Math.round(targetValue * easeOutCubic);
          
          element.textContent = currentValue;
          
          if (progress < 1) {
            requestAnimationFrame(animate);
          }
        };
        
        requestAnimationFrame(animate);
      });
    }

    unload() {
      console.log("SaciadaCalculator unloaded:", this.section);
      
      // Clean up event listeners
      if (this.weightSlider) {
        this.weightSlider.removeEventListener('input', this.boundHandleWeightChange);
      }
      if (this.heightSlider) {
        this.heightSlider.removeEventListener('input', this.boundHandleHeightChange);
      }
      
      // Clear debounced function
      if (this.debouncedCalculateResults) {
        this.debouncedCalculateResults.cancel();
      }
    }
  }
);

// -----------------------------------------------------------------------------
// Catalog Grid Section
// -----------------------------------------------------------------------------
registerSectionClass(
  "ShpfltCatalogGrid",
  class {
    constructor(section) {
      this.section = section;
      this.wrapper = section.querySelector('.shpflt__catalog-grid');
      if (!this.wrapper) return;

      this.tabsContainer = section.querySelector('.shpflt__catalog-grid-tabs');
      this.contentContainer = section.querySelector('.shpflt__catalog-grid-content');
      this.tabs = null;
      this.tabContents = null;
      this.blocks = [];

      this.boundHandleTabClick = this.handleTabClick.bind(this);
      this.boundHandleBlockSelect = this.handleBlockSelect.bind(this);
      this.boundHandleSectionSelect = this.handleSectionSelect.bind(this);

      this.initBlocks();
    }

    initBlocks() {
      const blocks = this.section.querySelectorAll("[data-block-type]");
      blocks.forEach((block) => {
        const blockType = toUpperFirst(toCamelCase(block.getAttribute("data-block-type") || ""));
        const BlockClass = getSectionBlockClass(blockType);
        if (BlockClass) {
          const blockInstance = new BlockClass(block, this.section);
          blockInstance.load();
          this.blocks.push(blockInstance);
        }
      });
    }

    load() {
      if (!this.wrapper) return;

      console.log("CatalogGrid loaded:", this.section);
      this.initMenuStructure();
    }

    initMenuStructure(loadEvent = false) {
      if (!this.contentContainer) return;

      // Get tabs and tab contents after they're teleported by Alpine
      this.tabs = Array.from(this.tabsContainer.querySelectorAll('.shpflt__catalog-grid-tab'));
      this.tabContents = Array.from(this.contentContainer.querySelectorAll('.tab-content'));

      // If no content yet, initialize Alpine tree and try again
      if (this.tabs.length === 0 || this.tabContents.length === 0) {
        if (window.Alpine && typeof Alpine.initTree === 'function') {
          Alpine.initTree(this.section);
        }
        // Retry after a small delay to let Alpine complete
        return this.initMenuStructure(loadEvent);
      }

      // Bind tab click handlers
      this.tabs.forEach(tab => {
        tab.addEventListener('click', this.boundHandleTabClick);
      });

      // Attach editor events
      this.attachEvents();

      // Set up initial state - activate first tab
      if (this.tabs.length > 0 && this.tabContents.length > 0) {
        this.switchToTab(this.tabs[0], false);
      }
    }

    attachEvents() {
      // Listen for block selection in theme editor
      document.addEventListener('shopify:block:select', this.boundHandleBlockSelect);
      document.addEventListener('shopify:section:select', this.boundHandleSectionSelect);
    }

    switchToTab(tab, triggerEvents = true) {
      const tabId = tab.getAttribute('data-tab');
      if (!tabId) return;

      // Update active tab
      if (this.tabs) {
        this.tabs.forEach(t => {
          t.classList.remove('is-active');
          t.classList.remove('active');
        });
        tab.classList.add('is-active');
      }

      if (tab.classList.contains('shpflt__catalog-grid-link')) {
        return;
      }

      // Update active content - use 'active' class for tab-content mixin
      if (this.tabContents) {
        this.tabContents.forEach(content => {
          if (content.getAttribute('data-tab-content') === tabId) {
            content.classList.add('active');
          } else {
            content.classList.remove('active');
          }
        });
      }
    }

    handleTabClick(event) {
      const clickedTab = event.currentTarget;
      this.switchToTab(clickedTab, true);
    }

    handleBlockSelect(event) {
      const block = event.target.closest('.shpflt__catalog-tab');
      if (!block) return;
      
      const blockId = block.getAttribute('id');
      const tab = this.section.querySelector(`.shpflt__catalog-grid-tab[data-tab="${blockId}"]`);
      
      if (tab) {
        this.switchToTab(tab, true);
        // Scroll tab into view if needed
        tab.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }
    }

    handleSectionSelect(event) {
      // Reinitialize menu structure when section is selected in editor
      // if (this.contentContainer) {
      //   setTimeout(() => this.initMenuStructure(true), 100);
      // }
    }

    unload() {
      if (!this.wrapper) return;

      console.log("CatalogGrid unloaded:", this.section);

      // Unload all blocks
      this.blocks.forEach(blockInstance => {
        if (typeof blockInstance.unload === "function") {
          blockInstance.unload();
        }
      });

      // Remove event listeners
      document.removeEventListener('shopify:block:select', this.boundHandleBlockSelect);
      document.removeEventListener('shopify:section:select', this.boundHandleSectionSelect);

      if (this.tabs) {
        this.tabs.forEach(tab => {
          tab.removeEventListener('click', this.boundHandleTabClick);
        });
      }

      // Clean up state
      this.tabs = null;
      this.tabContents = null;
      this.blocks = [];
    }
  }
);

registerSectionClass(
  "ShpfltBlogHighlights",
  class {
    constructor(section) {
      this.section = section;
      this.wrapper = section.querySelector(
        '[data-section-type="shpflt-blog-highlights"]'
      );
    }

    load() {
      if (!this.wrapper) return;
      console.log("ShpfltBlogHighlights loaded:", this.section);
    }

    unload() {
      if (!this.wrapper) return;
      console.log("ShpfltBlogHighlights unloaded:", this.section);
    }
  }
);

registerSectionClass(
  "ShpfltKeyBenefits",
  class {
    constructor(section) {
      this.section = section;
      this.wrapper = section.querySelector(
        '[data-section-type="shpflt-key-benefits"]'
      );
      this.container = null;
    }

    load() {
      if (!this.wrapper) return;
      console.log("[ShpfltKeyBenefits] loaded:", this.section);
      
      this.container = this.wrapper.querySelector(
        ".shpflt__key-benefits__container"
      );
      
      if (!this.container) {
        console.warn("[ShpfltKeyBenefits] container missing");
        return;
      }
    }

    unload() {
      if (!this.wrapper) return;
      console.log("[ShpfltKeyBenefits] unloaded:", this.section);
      this.container = null;
    }
  }
);

document.addEventListener("DOMContentLoaded", () => {
  new ShpfltTheme();
});